

class MetaobjectFacets {
  constructor() {
    this.activeFilters = new Map();
    this.allProducts = [];
    this.originalProducts = []; // Store original page products for restoration
    this.isProcessing = false;
    this.isClientFiltering = false; // Track if we're in client-side filtering mode
    this.displayValues = {
    "gid://shopify/Metaobject/99368927310": "Bluetooth",
    "gid://shopify/Metaobject/99368960078": "USB",
    "gid://shopify/Metaobject/99368992846": "HDMI",
    "gid://shopify/Metaobject/133697175630": "3.5 mm",
    "gid://shopify/Metaobject/149741994062": "Display port",
    "gid://shopify/Metaobject/99369025614": "Soundbar",
    "gid://shopify/Metaobject/163877650510": "Subwoofer",
    "gid://shopify/Metaobject/163877748814": "Center channel",
    "gid://shopify/Metaobject/199343439950": "Portable",
    "gid://shopify/Metaobject/102733578318": "Bijela",
    "gid://shopify/Metaobject/133859606606": "Blue",
    "gid://shopify/Metaobject/99369091150": "Bluetooth",
    "gid://shopify/Metaobject/99369123918": "USB",
    "gid://shopify/Metaobject/99369189454": "HDMI",
    "gid://shopify/Metaobject/133697241166": "Wired",
    "gid://shopify/Metaobject/166797508686": "Wireless",
    "gid://shopify/Metaobject/218056589390": "Radio",
    "gid://shopify/Metaobject/99369156686": "Home audio",
    "gid://shopify/Metaobject/99371941966": "Home cinema",
    "gid://shopify/Metaobject/163877617742": "Professional audio",
    "gid://shopify/Metaobject/199343407182": "Portable audio",
    "gid://shopify/Metaobject/199343472718": "Outdoor use",
    "gid://shopify/Metaobject/102733807694": "Metal",
    "gid://shopify/Metaobject/146528141390": "Stainless steel",
    "gid://shopify/Metaobject/164660117582": "Rubber",
    "gid://shopify/Metaobject/164660183118": "Fabric",
    "gid://shopify/Metaobject/173355827278": "Plastic",
    "gid://shopify/Metaobject/182513401934": "Aluminum",
    "gid://shopify/Metaobject/182513434702": "Copper",
    "gid://shopify/Metaobject/193233322062": "Ceramic",
    "gid://shopify/Metaobject/204450594894": "Glass",
    "gid://shopify/Metaobject/211282001998": "Silicone",
    "gid://shopify/Metaobject/102734889038": "A+++",
    "gid://shopify/Metaobject/104867921998": "E",
    "gid://shopify/Metaobject/106379968590": "A",
    "gid://shopify/Metaobject/106520477774": "A++",
    "gid://shopify/Metaobject/107787157582": "D",
    "gid://shopify/Metaobject/107788927054": "B",
    "gid://shopify/Metaobject/107807965262": "F",
    "gid://shopify/Metaobject/107808227406": "C",
    "gid://shopify/Metaobject/108020203598": "A+",
    "gid://shopify/Metaobject/108035571790": "I",
    "gid://shopify/Metaobject/108079054926": "G",
    "gid://shopify/Metaobject/102735183950": "LED",
    "gid://shopify/Metaobject/130051473486": "LED LCD",
    "gid://shopify/Metaobject/130330034254": "QLED",
    "gid://shopify/Metaobject/130338586702": "DLED",
    "gid://shopify/Metaobject/149741961294": "IPS",
    "gid://shopify/Metaobject/149759754318": "VA",
    "gid://shopify/Metaobject/150568075342": "LCD",
    "gid://shopify/Metaobject/150767501390": "OLED",
    "gid://shopify/Metaobject/168757461070": "Mini-LED",
    "gid://shopify/Metaobject/181741846606": "WOLED",
    "gid://shopify/Metaobject/186742767694": "ULED",
    "gid://shopify/Metaobject/102735216718": "webOS",
    "gid://shopify/Metaobject/130051571790": "VIDAA Smart OS",
    "gid://shopify/Metaobject/130329935950": "Titan OS",
    "gid://shopify/Metaobject/130330230862": "Android TV",
    "gid://shopify/Metaobject/130331181134": "Tizen",
    "gid://shopify/Metaobject/211758022734": "Google TV",
    "gid://shopify/Metaobject/102735315022": "4K ultra HD",
    "gid://shopify/Metaobject/130052489294": "4K",
    "gid://shopify/Metaobject/130331443278": "Full HD",
    "gid://shopify/Metaobject/130356805710": "HD",
    "gid://shopify/Metaobject/131027206222": "1920 x 1080",
    "gid://shopify/Metaobject/131064791118": "2880x1800",
    "gid://shopify/Metaobject/131347349582": "2560 x 1440",
    "gid://shopify/Metaobject/149741928526": "1440p",
    "gid://shopify/Metaobject/149759164494": "3440 x 1440",
    "gid://shopify/Metaobject/150767206478": "5K ultra HD",
    "gid://shopify/Metaobject/168759918670": "768p",
    "gid://shopify/Metaobject/173450592334": "3840 x 2160",
    "gid://shopify/Metaobject/182952722510": "1366 x 768",
    "gid://shopify/Metaobject/184421810254": "1366 x 768",
    "gid://shopify/Metaobject/186741686350": "2160p",
    "gid://shopify/Metaobject/243456901198": "Ostalo",
    "gid://shopify/Metaobject/102735249486": "Smart TV",
    "gid://shopify/Metaobject/102735282254": "Built-in digital tuner",
    "gid://shopify/Metaobject/102735347790": "Screen mirroring",
    "gid://shopify/Metaobject/130051735630": "Ambient light sensor",
    "gid://shopify/Metaobject/130051768398": "HDR support",
    "gid://shopify/Metaobject/130051801166": "Internet TV",
    "gid://shopify/Metaobject/130051833934": "Noise reduction",
    "gid://shopify/Metaobject/130051866702": "Parental control",
    "gid://shopify/Metaobject/130051965006": "VESA mounting support",
    "gid://shopify/Metaobject/104867954766": "Samostojeći",
    "gid://shopify/Metaobject/104870248526": "Ugradbeni",
    "gid://shopify/Metaobject/163877781582": "Wall",
    "gid://shopify/Metaobject/163877879886": "Tabletop",
    "gid://shopify/Metaobject/199343374414": "Portable",
    "gid://shopify/Metaobject/104870838350": "54cm",
    "gid://shopify/Metaobject/106390257742": "60cm",
    "gid://shopify/Metaobject/106937843790": "50cm",
    "gid://shopify/Metaobject/106959536206": "30cm",
    "gid://shopify/Metaobject/107940708430": "64.5cm",
    "gid://shopify/Metaobject/108022628430": "50cm",
    "gid://shopify/Metaobject/108022792270": "44cm",
    "gid://shopify/Metaobject/108032163918": "45cm",
    "gid://shopify/Metaobject/108041437262": "62cm",
    "gid://shopify/Metaobject/108042190926": "59cm",
    "gid://shopify/Metaobject/108043042894": "29cm",
    "gid://shopify/Metaobject/108045959246": "25cm",
    "gid://shopify/Metaobject/108046745678": "59.5cm",
    "gid://shopify/Metaobject/108105990222": "65.2cm",
    "gid://shopify/Metaobject/108106678350": "59.8cm",
    "gid://shopify/Metaobject/115008143438": "48cm",
    "gid://shopify/Metaobject/169826877518": "79.2cm",
    "gid://shopify/Metaobject/169827270734": "59.2cm",
    "gid://shopify/Metaobject/169827663950": "71cm",
    "gid://shopify/Metaobject/169829204046": "56cm",
    "gid://shopify/Metaobject/171431493710": "59.4cm",
    "gid://shopify/Metaobject/172457295950": "70.5cm",
    "gid://shopify/Metaobject/172457689166": "91.3cm",
    "gid://shopify/Metaobject/172668780622": "110.5cm",
    "gid://shopify/Metaobject/172672057422": "90.5cm",
    "gid://shopify/Metaobject/172785598542": "79cm",
    "gid://shopify/Metaobject/175052456014": "54.5cm",
    "gid://shopify/Metaobject/175055831118": "91cm",
    "gid://shopify/Metaobject/175059697742": "91.5cm",
    "gid://shopify/Metaobject/175177990222": "98.5cm",
    "gid://shopify/Metaobject/175179235406": "128.5cm",
    "gid://shopify/Metaobject/175237267534": "90.8cm",
    "gid://shopify/Metaobject/175238643790": "55cm",
    "gid://shopify/Metaobject/175240118350": "130cm",
    "gid://shopify/Metaobject/175241134158": "47.5cm",
    "gid://shopify/Metaobject/175243329614": "55.4cm",
    "gid://shopify/Metaobject/178746654798": "62.5cm",
    "gid://shopify/Metaobject/178747080782": "89.1cm",
    "gid://shopify/Metaobject/178748719182": "79.4cm",
    "gid://shopify/Metaobject/178749833294": "44.8cm",
    "gid://shopify/Metaobject/178752684110": "59.6cm",
    "gid://shopify/Metaobject/182232514638": "130.5cm",
    "gid://shopify/Metaobject/182673440846": "91.4cm",
    "gid://shopify/Metaobject/183443193934": "70cm",
    "gid://shopify/Metaobject/183446765646": "28cm",
    "gid://shopify/Metaobject/185160499278": "57,5cm",
    "gid://shopify/Metaobject/185378963534": "53.4cm",
    "gid://shopify/Metaobject/185379422286": "66cm",
    "gid://shopify/Metaobject/185380012110": "49.6cm",
    "gid://shopify/Metaobject/185382076494": "59.7cm",
    "gid://shopify/Metaobject/185867599950": "78.7cm",
    "gid://shopify/Metaobject/186374488142": "54.6cm",
    "gid://shopify/Metaobject/186375077966": "54.9cm",
    "gid://shopify/Metaobject/186399948878": "27cm",
    "gid://shopify/Metaobject/186402701390": "52cm",
    "gid://shopify/Metaobject/186405060686": "53cm",
    "gid://shopify/Metaobject/186406142030": "80cm",
    "gid://shopify/Metaobject/189455925326": "70.8cm",
    "gid://shopify/Metaobject/190767333454": "78cm",
    "gid://shopify/Metaobject/191222579278": "57.6cm",
    "gid://shopify/Metaobject/195206774862": "28.8cm",
    "gid://shopify/Metaobject/195346006094": "89.4cm",
    "gid://shopify/Metaobject/198462308430": "83.3cm",
    "gid://shopify/Metaobject/203021975630": "45.6cm",
    "gid://shopify/Metaobject/204455084110": "76cm",
    "gid://shopify/Metaobject/207042347086": "47cm",
    "gid://shopify/Metaobject/211280986190": "83cm",
    "gid://shopify/Metaobject/213308964942": "38cm",
    "gid://shopify/Metaobject/220783738958": "90cm",
    "gid://shopify/Metaobject/223048237134": "60.6cm",
    "gid://shopify/Metaobject/234043277390": "85.5cm",
    "gid://shopify/Metaobject/234045669454": "109cm",
    "gid://shopify/Metaobject/106378526798": "177.5cm",
    "gid://shopify/Metaobject/106391502926": "185cm",
    "gid://shopify/Metaobject/107807768654": "150cm",
    "gid://shopify/Metaobject/108018466894": "180cm",
    "gid://shopify/Metaobject/108021776462": "186cm",
    "gid://shopify/Metaobject/108021940302": "145cm",
    "gid://shopify/Metaobject/108022202446": "82cm",
    "gid://shopify/Metaobject/108022857806": "51cm",
    "gid://shopify/Metaobject/113263837262": "203cm",
    "gid://shopify/Metaobject/113896620110": "184.5cm",
    "gid://shopify/Metaobject/115034259534": "85cm",
    "gid://shopify/Metaobject/169938387022": "135.7cm",
    "gid://shopify/Metaobject/172457853006": "179cm",
    "gid://shopify/Metaobject/172654854222": "146.5cm",
    "gid://shopify/Metaobject/172655935566": "152.8cm",
    "gid://shopify/Metaobject/172656918606": "203.5cm",
    "gid://shopify/Metaobject/172668420174": "84cm",
    "gid://shopify/Metaobject/172669042766": "86cm",
    "gid://shopify/Metaobject/172672286798": "84.5cm",
    "gid://shopify/Metaobject/172785238094": "193.5cm",
    "gid://shopify/Metaobject/175052750926": "143cm",
    "gid://shopify/Metaobject/175053275214": "85.5cm",
    "gid://shopify/Metaobject/175053733966": "144.8cm",
    "gid://shopify/Metaobject/175060680782": "178.6cm",
    "gid://shopify/Metaobject/175178055758": "87cm",
    "gid://shopify/Metaobject/175235760206": "200cm",
    "gid://shopify/Metaobject/175237365838": "179.3cm",
    "gid://shopify/Metaobject/175238479950": "172cm",
    "gid://shopify/Metaobject/175238676558": "144cm",
    "gid://shopify/Metaobject/175241330766": "84.2cm",
    "gid://shopify/Metaobject/175242575950": "143.4cm",
    "gid://shopify/Metaobject/175243100238": "161.3cm",
    "gid://shopify/Metaobject/175243362382": "161cm",
    "gid://shopify/Metaobject/175822635086": "88cm",
    "gid://shopify/Metaobject/175825616974": "176.9cm",
    "gid://shopify/Metaobject/178192384078": "178cm",
    "gid://shopify/Metaobject/178746785870": "85.4cm",
    "gid://shopify/Metaobject/178747146318": "85.3cm",
    "gid://shopify/Metaobject/178753503310": "81.8cm",
    "gid://shopify/Metaobject/178753994830": "177cm",
    "gid://shopify/Metaobject/179379142734": "182cm",
    "gid://shopify/Metaobject/181645967438": "189cm",
    "gid://shopify/Metaobject/181759377486": "160cm",
    "gid://shopify/Metaobject/181999009870": "151cm",
    "gid://shopify/Metaobject/182232940622": "187.5cm",
    "gid://shopify/Metaobject/182237921358": "193cm",
    "gid://shopify/Metaobject/182673506382": "178.5cm",
    "gid://shopify/Metaobject/186331037774": "187.7cm",
    "gid://shopify/Metaobject/186374553678": "177.2cm",
    "gid://shopify/Metaobject/186375766094": "81.9cm",
    "gid://shopify/Metaobject/190651564110": "190cm",
    "gid://shopify/Metaobject/195393617998": "150.8cm",
    "gid://shopify/Metaobject/204451479630": "121.5cm",
    "gid://shopify/Metaobject/207042478158": "49.6cm",
    "gid://shopify/Metaobject/208401596494": "170cm",
    "gid://shopify/Metaobject/208402546766": "188cm",
    "gid://shopify/Metaobject/208402874446": "201cm",
    "gid://shopify/Metaobject/208403267662": "142cm",
    "gid://shopify/Metaobject/234457301070": "185.6cm",
    "gid://shopify/Metaobject/106378788942": "5 godina",
    "gid://shopify/Metaobject/106378854478": "4 godine",
    "gid://shopify/Metaobject/106379935822": "7 godina",
    "gid://shopify/Metaobject/106520379470": "2 + 3 godine",
    "gid://shopify/Metaobject/106941546574": "5 + 2 godine",
    "gid://shopify/Metaobject/106953179214": "2 godine",
    "gid://shopify/Metaobject/108140724302": "3 godine",
    "gid://shopify/Metaobject/108143214670": "1 godina",
    "gid://shopify/Metaobject/130330132558": "3+2 godine",
    "gid://shopify/Metaobject/131890446414": "4+",
    "gid://shopify/Metaobject/106390650958": "14 setova",
    "gid://shopify/Metaobject/106941448270": "13 setova",
    "gid://shopify/Metaobject/108031869006": "12 setova",
    "gid://shopify/Metaobject/108032131150": "10 setova",
    "gid://shopify/Metaobject/108033998926": "9 setova",
    "gid://shopify/Metaobject/108035080270": "15+",
    "gid://shopify/Metaobject/108035211342": "16 setova",
    "gid://shopify/Metaobject/175697592398": "11 setova",
    "gid://shopify/Metaobject/106390814798": "9 programa",
    "gid://shopify/Metaobject/106941415502": "5 programa",
    "gid://shopify/Metaobject/106941513806": "4 programa",
    "gid://shopify/Metaobject/108031803470": "6 programa",
    "gid://shopify/Metaobject/108033966158": "7 programa",
    "gid://shopify/Metaobject/108035047502": "8 programa",
    "gid://shopify/Metaobject/108035604558": "3 programa",
    "gid://shopify/Metaobject/169816817742": "10+",
    "gid://shopify/Metaobject/106937778254": "Električni",
    "gid://shopify/Metaobject/106938007630": "Kombinovani",
    "gid://shopify/Metaobject/107787452494": "Samostojeći",
    "gid://shopify/Metaobject/107787485262": "Ugradbeni",
    "gid://shopify/Metaobject/107787976782": "Perilica",
    "gid://shopify/Metaobject/107788828750": "Sušilica",
    "gid://shopify/Metaobject/107790499918": "Masina za veš",
    "gid://shopify/Metaobject/107807703118": "Ladičari",
    "gid://shopify/Metaobject/107807998030": "Ugradbena",
    "gid://shopify/Metaobject/130470772814": "Nagibni",
    "gid://shopify/Metaobject/130474410062": "Fiksni",
    "gid://shopify/Metaobject/131713302606": "ATX",
    "gid://shopify/Metaobject/131713368142": "Micro - ATX",
    "gid://shopify/Metaobject/131713400910": "Mini - ITX",
    "gid://shopify/Metaobject/132147118158": "mATX",
    "gid://shopify/Metaobject/132481908814": "Žični",
    "gid://shopify/Metaobject/132481941582": "Bežični",
    "gid://shopify/Metaobject/132482334798": "Mehanička",
    "gid://shopify/Metaobject/132482367566": "Klasična",
    "gid://shopify/Metaobject/133696716878": "Zračni ",
    "gid://shopify/Metaobject/133696782414": "Vodeni",
    "gid://shopify/Metaobject/146521653326": "Standardni",
    "gid://shopify/Metaobject/146521686094": "Robot",
    "gid://shopify/Metaobject/146521751630": "Štapni ",
    "gid://shopify/Metaobject/146894880846": "Samostojeća",
    "gid://shopify/Metaobject/163701850190": "Pročišćivač zraka",
    "gid://shopify/Metaobject/163701981262": "Osvježivač zraka",
    "gid://shopify/Metaobject/163702014030": "Ovlaživač zraka",
    "gid://shopify/Metaobject/163702046798": "Odvlaživač zraka",
    "gid://shopify/Metaobject/172668977230": "Škrinja ",
    "gid://shopify/Metaobject/185539362894": "Plinski",
    "gid://shopify/Metaobject/187076706382": "Membranska",
    "gid://shopify/Metaobject/106938499150": "4 polja",
    "gid://shopify/Metaobject/106959503438": "2 polja",
    "gid://shopify/Metaobject/108045860942": "1 polja",
    "gid://shopify/Metaobject/216931270734": "3 polja",
    "gid://shopify/Metaobject/106956390478": "Staklokeramička",
    "gid://shopify/Metaobject/106957832270": "Kombinovana",
    "gid://shopify/Metaobject/106958028878": "Indukcijska",
    "gid://shopify/Metaobject/106960126030": "Plinska",
    "gid://shopify/Metaobject/107778441294": "71L",
    "gid://shopify/Metaobject/107778768974": "55L",
    "gid://shopify/Metaobject/107782013006": "293L",
    "gid://shopify/Metaobject/107782111310": "262L",
    "gid://shopify/Metaobject/107786862670": "65L",
    "gid://shopify/Metaobject/107807735886": "240L",
    "gid://shopify/Metaobject/107808292942": "74L",
    "gid://shopify/Metaobject/107923472462": "50L",
    "gid://shopify/Metaobject/107934777422": "68L",
    "gid://shopify/Metaobject/107939561550": "72L",
    "gid://shopify/Metaobject/107939692622": "70L",
    "gid://shopify/Metaobject/107964203086": "45L",
    "gid://shopify/Metaobject/108017844302": "227L",
    "gid://shopify/Metaobject/108018434126": "209L",
    "gid://shopify/Metaobject/108019187790": "210L",
    "gid://shopify/Metaobject/108019875918": "286L",
    "gid://shopify/Metaobject/108020564046": "262L",
    "gid://shopify/Metaobject/108021448782": "254L",
    "gid://shopify/Metaobject/108021514318": "271L",
    "gid://shopify/Metaobject/108021743694": "304L",
    "gid://shopify/Metaobject/108021907534": "213L",
    "gid://shopify/Metaobject/108022038606": "340L",
    "gid://shopify/Metaobject/108022136910": "128L",
    "gid://shopify/Metaobject/108022431822": "274L",
    "gid://shopify/Metaobject/108022661198": "89L",
    "gid://shopify/Metaobject/108022825038": "51L",
    "gid://shopify/Metaobject/108022956110": "341L",
    "gid://shopify/Metaobject/108023480398": "299L",
    "gid://shopify/Metaobject/108046909518": "66L",
    "gid://shopify/Metaobject/108047073358": "72L",
    "gid://shopify/Metaobject/108047499342": "77L",
    "gid://shopify/Metaobject/108048318542": "76L",
    "gid://shopify/Metaobject/113245257806": "387L",
    "gid://shopify/Metaobject/113896521806": "461L",
    "gid://shopify/Metaobject/114051317838": "386L",
    "gid://shopify/Metaobject/114352717902": "338L",
    "gid://shopify/Metaobject/115021512782": "88L",
    "gid://shopify/Metaobject/115050774606": "65L",
    "gid://shopify/Metaobject/145952407630": "6L",
    "gid://shopify/Metaobject/146149507150": "5,7L",
    "gid://shopify/Metaobject/146149867598": "4,2L",
    "gid://shopify/Metaobject/146150391886": "8,2L",
    "gid://shopify/Metaobject/146150588494": "8,3L",
    "gid://shopify/Metaobject/146150785102": "8L",
    "gid://shopify/Metaobject/146151047246": "6,5L",
    "gid://shopify/Metaobject/146152259662": "9L",
    "gid://shopify/Metaobject/146152915022": "5L",
    "gid://shopify/Metaobject/146225299534": "1,6L",
    "gid://shopify/Metaobject/146236375118": "4L",
    "gid://shopify/Metaobject/146236506190": "2,5L",
    "gid://shopify/Metaobject/146236670030": "1,6L",
    "gid://shopify/Metaobject/146238111822": "4,25L",
    "gid://shopify/Metaobject/146238505038": "3,5L",
    "gid://shopify/Metaobject/146238898254": "3L",
    "gid://shopify/Metaobject/146244862030": "475ml",
    "gid://shopify/Metaobject/146245091406": "1L",
    "gid://shopify/Metaobject/146245353550": "1,75L",
    "gid://shopify/Metaobject/146245484622": "590ml",
    "gid://shopify/Metaobject/146245943374": "1,8L",
    "gid://shopify/Metaobject/146246631502": "900ml",
    "gid://shopify/Metaobject/146246926414": "600ml",
    "gid://shopify/Metaobject/146247712846": "1,5L",
    "gid://shopify/Metaobject/146248138830": "1,6l",
    "gid://shopify/Metaobject/146248400974": "800ml",
    "gid://shopify/Metaobject/146528436302": "1,7L",
    "gid://shopify/Metaobject/146541903950": "330ml",
    "gid://shopify/Metaobject/146542198862": "300ml",
    "gid://shopify/Metaobject/146894291022": "20L",
    "gid://shopify/Metaobject/146894946382": "23L",
    "gid://shopify/Metaobject/146911690830": "17L",
    "gid://shopify/Metaobject/146913099854": "25L",
    "gid://shopify/Metaobject/146916933710": "30L",
    "gid://shopify/Metaobject/169835233358": "304L",
    "gid://shopify/Metaobject/169937764430": "367L",
    "gid://shopify/Metaobject/169938059342": "350L",
    "gid://shopify/Metaobject/169938190414": "168L",
    "gid://shopify/Metaobject/171428085838": "72L",
    "gid://shopify/Metaobject/171430674510": "73L",
    "gid://shopify/Metaobject/171431034958": "60L",
    "gid://shopify/Metaobject/172457328718": "462L",
    "gid://shopify/Metaobject/172457754702": "416L",
    "gid://shopify/Metaobject/172458639438": "344L",
    "gid://shopify/Metaobject/172654886990": "223L",
    "gid://shopify/Metaobject/172655870030": "229L",
    "gid://shopify/Metaobject/172656853070": "355L",
    "gid://shopify/Metaobject/172668354638": "95L",
    "gid://shopify/Metaobject/172669009998": "308L",
    "gid://shopify/Metaobject/172672221262": "90.5L",
    "gid://shopify/Metaobject/172784877646": "306L",
    "gid://shopify/Metaobject/172785664078": "466L",
    "gid://shopify/Metaobject/173215678542": "0,8L",
    "gid://shopify/Metaobject/175052554318": "206L",
    "gid://shopify/Metaobject/175053176910": "130L",
    "gid://shopify/Metaobject/175053537358": "220L",
    "gid://shopify/Metaobject/175055863886": "580L",
    "gid://shopify/Metaobject/175059796046": "550L",
    "gid://shopify/Metaobject/175177269326": "300L",
    "gid://shopify/Metaobject/175178022990": "250L",
    "gid://shopify/Metaobject/175179038798": "143L",
    "gid://shopify/Metaobject/175179333710": "357L",
    "gid://shopify/Metaobject/175179497550": "547L",
    "gid://shopify/Metaobject/175179726926": "121L",
    "gid://shopify/Metaobject/175235727438": "331L",
    "gid://shopify/Metaobject/175237333070": "519L",
    "gid://shopify/Metaobject/175239037006": "280L",
    "gid://shopify/Metaobject/175240183886": "284L",
    "gid://shopify/Metaobject/175241265230": "82L",
    "gid://shopify/Metaobject/175241494606": "92L",
    "gid://shopify/Metaobject/175242543182": "242L",
    "gid://shopify/Metaobject/175243034702": "230L",
    "gid://shopify/Metaobject/175253717070": "269L",
    "gid://shopify/Metaobject/175253782606": "562L",
    "gid://shopify/Metaobject/175822536782": "129L",
    "gid://shopify/Metaobject/175824896078": "200L",
    "gid://shopify/Metaobject/175825584206": "270L",
    "gid://shopify/Metaobject/178192318542": "574L",
    "gid://shopify/Metaobject/178746753102": "142L",
    "gid://shopify/Metaobject/178747113550": "191L",
    "gid://shopify/Metaobject/178747703374": "413L",
    "gid://shopify/Metaobject/178748948558": "485L",
    "gid://shopify/Metaobject/178752127054": "19.8L",
    "gid://shopify/Metaobject/178753405006": "133L",
    "gid://shopify/Metaobject/178753896526": "246L",
    "gid://shopify/Metaobject/178754388046": "252L",
    "gid://shopify/Metaobject/179379077198": "282L",
    "gid://shopify/Metaobject/180136181838": "400ml",
    "gid://shopify/Metaobject/181645934670": "328L",
    "gid://shopify/Metaobject/181996781646": "107L",
    "gid://shopify/Metaobject/181997240398": "90L",
    "gid://shopify/Metaobject/182227664974": "80L",
    "gid://shopify/Metaobject/182232612942": "410L",
    "gid://shopify/Metaobject/182232907854": "609L",
    "gid://shopify/Metaobject/182240346190": "1L",
    "gid://shopify/Metaobject/182673473614": "584L",
    "gid://shopify/Metaobject/183303962702": "500ml",
    "gid://shopify/Metaobject/183305535566": "750ml",
    "gid://shopify/Metaobject/183428218958": "1,2L",
    "gid://shopify/Metaobject/183447486542": "700ml",
    "gid://shopify/Metaobject/184952324174": "336L",
    "gid://shopify/Metaobject/185378046030": "389L",
    "gid://shopify/Metaobject/185380864078": "165L",
    "gid://shopify/Metaobject/185538314318": "253L",
    "gid://shopify/Metaobject/185539297358": "57L",
    "gid://shopify/Metaobject/185867534414": "198L",
    "gid://shopify/Metaobject/186330972238": "560L",
    "gid://shopify/Metaobject/186374520910": "257L",
    "gid://shopify/Metaobject/186375110734": "217L",
    "gid://shopify/Metaobject/186375667790": "127L",
    "gid://shopify/Metaobject/186378584142": "58L",
    "gid://shopify/Metaobject/189452157006": "8.6L",
    "gid://shopify/Metaobject/189452582990": "267L",
    "gid://shopify/Metaobject/189453008974": "260L",
    "gid://shopify/Metaobject/189454647374": "290L",
    "gid://shopify/Metaobject/189456023630": "508L",
    "gid://shopify/Metaobject/190654578766": "398L",
    "gid://shopify/Metaobject/195212181582": "266L",
    "gid://shopify/Metaobject/195335028814": "7.2L",
    "gid://shopify/Metaobject/195400433742": "301L",
    "gid://shopify/Metaobject/195635314766": "310L",
    "gid://shopify/Metaobject/195636199502": "0.75L",
    "gid://shopify/Metaobject/195643244622": "2L",
    "gid://shopify/Metaobject/196418764878": "1.75L",
    "gid://shopify/Metaobject/196420468814": "1.5L",
    "gid://shopify/Metaobject/196420829262": "0.8L",
    "gid://shopify/Metaobject/196442554446": "7L",
    "gid://shopify/Metaobject/196446388302": "5.2L",
    "gid://shopify/Metaobject/197100470350": "1.7L",
    "gid://shopify/Metaobject/197101813838": "0.35L",
    "gid://shopify/Metaobject/198469386318": "456L",
    "gid://shopify/Metaobject/198582534222": "532L",
    "gid://shopify/Metaobject/204451446862": "175L",
    "gid://shopify/Metaobject/204457508942": "640L",
    "gid://shopify/Metaobject/204495519822": "316L",
    "gid://shopify/Metaobject/205732282446": "10.9L",
    "gid://shopify/Metaobject/205736575054": "6.1L",
    "gid://shopify/Metaobject/205745782862": "43L",
    "gid://shopify/Metaobject/205746077774": "67L",
    "gid://shopify/Metaobject/207038382158": "0.5L",
    "gid://shopify/Metaobject/207040643150": "321L",
    "gid://shopify/Metaobject/207042445390": "46L",
    "gid://shopify/Metaobject/207042773070": "371L",
    "gid://shopify/Metaobject/207922561102": "255l",
    "gid://shopify/Metaobject/208401629262": "268L",
    "gid://shopify/Metaobject/208401956942": "288L",
    "gid://shopify/Metaobject/208403333198": "160L",
    "gid://shopify/Metaobject/208403660878": "273L",
    "gid://shopify/Metaobject/210316132430": "7L",
    "gid://shopify/Metaobject/211338952782": "710ml",
    "gid://shopify/Metaobject/211340132430": "1.8L",
    "gid://shopify/Metaobject/213300445262": "38L",
    "gid://shopify/Metaobject/216936349774": "1L",
    "gid://shopify/Metaobject/220786589774": "98L",
    "gid://shopify/Metaobject/223048269902": "141L",
    "gid://shopify/Metaobject/223050301518": "330L",
    "gid://shopify/Metaobject/230077562958": "6.5L",
    "gid://shopify/Metaobject/230077628494": "10L",
    "gid://shopify/Metaobject/230077661262": "12L",
    "gid://shopify/Metaobject/234044555342": "442L",
    "gid://shopify/Metaobject/234045702222": "287L",
    "gid://shopify/Metaobject/234449829966": "324L",
    "gid://shopify/Metaobject/107788042318": "1000",
    "gid://shopify/Metaobject/107790401614": "1400",
    "gid://shopify/Metaobject/108073746510": "1200",
    "gid://shopify/Metaobject/190493589582": "1600",
    "gid://shopify/Metaobject/191777636430": "1300",
    "gid://shopify/Metaobject/107788107854": "8",
    "gid://shopify/Metaobject/107790565454": "11",
    "gid://shopify/Metaobject/108073025614": "7",
    "gid://shopify/Metaobject/108073353294": "6",
    "gid://shopify/Metaobject/108075810894": "9",
    "gid://shopify/Metaobject/108076073038": "6.5",
    "gid://shopify/Metaobject/108076728398": "10",
    "gid://shopify/Metaobject/169832611918": "10.5",
    "gid://shopify/Metaobject/172345327694": "12",
    "gid://shopify/Metaobject/107788468302": "8",
    "gid://shopify/Metaobject/107790598222": "11",
    "gid://shopify/Metaobject/107790696526": "6",
    "gid://shopify/Metaobject/108079284302": "10",
    "gid://shopify/Metaobject/108102451278": "9",
    "gid://shopify/Metaobject/108102975566": "7",
    "gid://shopify/Metaobject/108103696462": "5",
    "gid://shopify/Metaobject/108103925838": "4",
    "gid://shopify/Metaobject/107789877326": "61.5cm",
    "gid://shopify/Metaobject/107790041166": "52cm",
    "gid://shopify/Metaobject/107790434382": "60cm",
    "gid://shopify/Metaobject/108072173646": "51cm",
    "gid://shopify/Metaobject/108072992846": "50cm",
    "gid://shopify/Metaobject/108073779278": "52.7cm",
    "gid://shopify/Metaobject/108075319374": "55cm",
    "gid://shopify/Metaobject/108075778126": "56cm",
    "gid://shopify/Metaobject/108075909198": "47cm",
    "gid://shopify/Metaobject/108076040270": "54cm",
    "gid://shopify/Metaobject/108076302414": "54.6cm",
    "gid://shopify/Metaobject/108076466254": "49.6cm",
    "gid://shopify/Metaobject/108076630094": "53cm",
    "gid://shopify/Metaobject/108076695630": "61cm",
    "gid://shopify/Metaobject/108076925006": "44cm",
    "gid://shopify/Metaobject/108077645902": "49.7cm",
    "gid://shopify/Metaobject/108077973582": "43.5cm",
    "gid://shopify/Metaobject/108078104654": "66cm",
    "gid://shopify/Metaobject/108079022158": "56.3cm",
    "gid://shopify/Metaobject/108079251534": "69cm",
    "gid://shopify/Metaobject/108101632078": "54.5cm",
    "gid://shopify/Metaobject/108102910030": "50.8cm",
    "gid://shopify/Metaobject/108103237710": "54.3cm",
    "gid://shopify/Metaobject/108103663694": "47.5cm",
    "gid://shopify/Metaobject/165515362382": "44.5cm",
    "gid://shopify/Metaobject/169808756814": "59cm",
    "gid://shopify/Metaobject/169809739854": "61.3cm",
    "gid://shopify/Metaobject/169814556750": "58.8cm",
    "gid://shopify/Metaobject/169833726030": "62.5cm",
    "gid://shopify/Metaobject/169834479694": "64cm",
    "gid://shopify/Metaobject/169934913614": "45cm",
    "gid://shopify/Metaobject/169935470670": "47.4cm",
    "gid://shopify/Metaobject/169936388174": "58.5cm",
    "gid://shopify/Metaobject/169937141838": "63cm",
    "gid://shopify/Metaobject/171045814350": "63.8cm",
    "gid://shopify/Metaobject/171059281998": "63.6cm",
    "gid://shopify/Metaobject/172339265614": "56.8cm",
    "gid://shopify/Metaobject/172341526606": "59.6cm",
    "gid://shopify/Metaobject/172343230542": "46.5cm",
    "gid://shopify/Metaobject/172445827150": "52.5cm",
    "gid://shopify/Metaobject/172457558094": "56.5cm",
    "gid://shopify/Metaobject/172461523022": "60.9cm",
    "gid://shopify/Metaobject/172683329614": "57cm",
    "gid://shopify/Metaobject/181762654286": "58cm",
    "gid://shopify/Metaobject/185285836878": "42cm",
    "gid://shopify/Metaobject/186329890894": "49.5cm",
    "gid://shopify/Metaobject/190493327438": "37.8cm",
    "gid://shopify/Metaobject/190493622350": "57.6cm",
    "gid://shopify/Metaobject/191771869262": "54.7cm",
    "gid://shopify/Metaobject/191776784462": "59.90cm",
    "gid://shopify/Metaobject/204436602958": "46cm",
    "gid://shopify/Metaobject/204439355470": "44.6cm",
    "gid://shopify/Metaobject/204638552142": "57.5cm",
    "gid://shopify/Metaobject/223047778382": "59.5cm",
    "gid://shopify/Metaobject/107802263630": "A++",
    "gid://shopify/Metaobject/108140363854": "A+",
    "gid://shopify/Metaobject/108141314126": "A+++",
    "gid://shopify/Metaobject/107802230862": "A++",
    "gid://shopify/Metaobject/107802296398": "A+",
    "gid://shopify/Metaobject/108141281358": "A+++",
    "gid://shopify/Metaobject/107802853454": "Ne",
    "gid://shopify/Metaobject/107803476046": "Da",
    "gid://shopify/Metaobject/107803115598": "5",
    "gid://shopify/Metaobject/107803541582": "3.4kW",
    "gid://shopify/Metaobject/108139839566": "5kW",
    "gid://shopify/Metaobject/108140953678": "7kW",
    "gid://shopify/Metaobject/108141150286": "3.5kW",
    "gid://shopify/Metaobject/108141445198": "3.52kW",
    "gid://shopify/Metaobject/108141936718": "5.6kW",
    "gid://shopify/Metaobject/108142329934": "5.3kW",
    "gid://shopify/Metaobject/184423874638": "2.6kW",
    "gid://shopify/Metaobject/184564383822": "6.5kW",
    "gid://shopify/Metaobject/184569233486": "6.3kW",
    "gid://shopify/Metaobject/184621891662": "3.2kW",
    "gid://shopify/Metaobject/184623628366": "5.4kW",
    "gid://shopify/Metaobject/107803082830": "5400",
    "gid://shopify/Metaobject/107803508814": "3.4",
    "gid://shopify/Metaobject/107897651278": "5.4",
    "gid://shopify/Metaobject/108139806798": "5.4kW",
    "gid://shopify/Metaobject/108140200014": "3.4kW",
    "gid://shopify/Metaobject/108140757070": "3.5kW",
    "gid://shopify/Metaobject/108140920910": "5kW",
    "gid://shopify/Metaobject/108141117518": "3.8kW",
    "gid://shopify/Metaobject/108141379662": "4.25kW",
    "gid://shopify/Metaobject/108141871182": "5.3kW",
    "gid://shopify/Metaobject/108142067790": "5.6kW",
    "gid://shopify/Metaobject/184423841870": "2.7kW",
    "gid://shopify/Metaobject/184564351054": "7.1kW",
    "gid://shopify/Metaobject/184568315982": "3.9kW",
    "gid://shopify/Metaobject/184569200718": "6.2kW",
    "gid://shopify/Metaobject/184621858894": "3.3kW",
    "gid://shopify/Metaobject/184625233998": "4.2kW",
    "gid://shopify/Metaobject/184643878990": "4kW",
    "gid://shopify/Metaobject/217717211214": "6.8kW",
    "gid://shopify/Metaobject/217720782926": "6.7kW",
    "gid://shopify/Metaobject/107925274702": "AC-powered",
    "gid://shopify/Metaobject/133697208398": "DC-powered",
    "gid://shopify/Metaobject/108048285774": "Wire rack",
    "gid://shopify/Metaobject/130051899470": "G",
    "gid://shopify/Metaobject/130051932238": "16:9",
    "gid://shopify/Metaobject/130052030542": "E",
    "gid://shopify/Metaobject/130051997774": "HDMI",
    "gid://shopify/Metaobject/130052063310": "Wi-Fi",
    "gid://shopify/Metaobject/130052096078": "Ethernet",
    "gid://shopify/Metaobject/130052128846": "USB",
    "gid://shopify/Metaobject/130052161614": "HDR10+",
    "gid://shopify/Metaobject/130052194382": "Dolby vision",
    "gid://shopify/Metaobject/130052980814": "65\"",
    "gid://shopify/Metaobject/130330165326": "55\"",
    "gid://shopify/Metaobject/130331410510": "40\"",
    "gid://shopify/Metaobject/130331541582": "43\"",
    "gid://shopify/Metaobject/130331639886": "50\"",
    "gid://shopify/Metaobject/130331705422": "75\"",
    "gid://shopify/Metaobject/130340192334": "58\"",
    "gid://shopify/Metaobject/130356707406": "32\"",
    "gid://shopify/Metaobject/131027566670": "15\"",
    "gid://shopify/Metaobject/131063185486": "16\"",
    "gid://shopify/Metaobject/131064725582": "14\"",
    "gid://shopify/Metaobject/131353018446": "17.3\"",
    "gid://shopify/Metaobject/149742616654": "34\"",
    "gid://shopify/Metaobject/149758935118": "23.8\"",
    "gid://shopify/Metaobject/149759918158": "27\"",
    "gid://shopify/Metaobject/150565847118": "25\"",
    "gid://shopify/Metaobject/150568009806": "24\"",
    "gid://shopify/Metaobject/150764421198": "31.5\"",
    "gid://shopify/Metaobject/168604368974": "85\"",
    "gid://shopify/Metaobject/171064459342": "24.5\"",
    "gid://shopify/Metaobject/171065049166": "22\"",
    "gid://shopify/Metaobject/171066982478": "26.7\"",
    "gid://shopify/Metaobject/178964561998": "15.6”",
    "gid://shopify/Metaobject/183822417998": "49”",
    "gid://shopify/Metaobject/186737459278": "100“",
    "gid://shopify/Metaobject/211757695054": "70\"",
    "gid://shopify/Metaobject/130470740046": "55 inča",
    "gid://shopify/Metaobject/130474377294": "75 inča",
    "gid://shopify/Metaobject/130475130958": "80 inča",
    "gid://shopify/Metaobject/130475425870": "65 inča",
    "gid://shopify/Metaobject/130475982926": "43 inča",
    "gid://shopify/Metaobject/130476441678": "70 inča",
    "gid://shopify/Metaobject/130483650638": "60 inča",
    "gid://shopify/Metaobject/131027042382": "Intel Core i5 12500H",
    "gid://shopify/Metaobject/131049685070": "AMD Ryzen 5 5625U",
    "gid://shopify/Metaobject/131050012750": "Intel Core i5 1235U ",
    "gid://shopify/Metaobject/131059908686": "AMD Ryzen 5 6600H",
    "gid://shopify/Metaobject/131060203598": "Intel core i3",
    "gid://shopify/Metaobject/131060334670": " Intel Core i3 1215U",
    "gid://shopify/Metaobject/131060367438": "AMD Ryzen 5 7520U",
    "gid://shopify/Metaobject/131060826190": "Intel Core i3 1315U",
    "gid://shopify/Metaobject/131062038606": "AMD Ryzen 5 5500U",
    "gid://shopify/Metaobject/131062169678": "Intel Core i5 12450H",
    "gid://shopify/Metaobject/131062988878": "Intel Core i7 13650HX",
    "gid://shopify/Metaobject/131063971918": "Intel Core i5 1235U",
    "gid://shopify/Metaobject/131064201294": "Intel Core i5 1335U",
    "gid://shopify/Metaobject/131064594510": "Intel Core Ultra 9 185H",
    "gid://shopify/Metaobject/131065020494": "Intel  Core i9 14900HX",
    "gid://shopify/Metaobject/131065774158": "Intel Core i3 N305",
    "gid://shopify/Metaobject/131065937998": "Intel Core Ultra 7 155H",
    "gid://shopify/Metaobject/131342270542": "AMD Ryzen 3 7320U",
    "gid://shopify/Metaobject/131342532686": "Intel Core i7 13620H",
    "gid://shopify/Metaobject/131343810638": "Intel Core i7 1365U",
    "gid://shopify/Metaobject/131344007246": "AMD Ryzen 7 7840HS",
    "gid://shopify/Metaobject/131344728142": "Intel Core i7 14650HX",
    "gid://shopify/Metaobject/131346792526": "Intel Core i5 12500H",
    "gid://shopify/Metaobject/131347382350": "AMD Ryzen 7 5700U",
    "gid://shopify/Metaobject/131348365390": "AMD Ryzen 8645HS",
    "gid://shopify/Metaobject/131348660302": "AMD Ryzen 7 7730U",
    "gid://shopify/Metaobject/131349971022": "AMD Ryzen 5 7535U",
    "gid://shopify/Metaobject/131351314510": "AMD Ryzen 5 7535HS",
    "gid://shopify/Metaobject/131352199246": "AMD Ryzen 5 7640HS",
    "gid://shopify/Metaobject/131352559694": "Intel Core i5 13500H ",
    "gid://shopify/Metaobject/178964496462": "AMD Ryzen 5 7530U",
    "gid://shopify/Metaobject/178966200398": " Intel Core i7-12650HX",
    "gid://shopify/Metaobject/178967347278": "AMD Ryzen 7 5825U",
    "gid://shopify/Metaobject/131027238990": "Windows",
    "gid://shopify/Metaobject/131027533902": "Free DOS",
    "gid://shopify/Metaobject/156917006414": "Android",
    "gid://shopify/Metaobject/178964725838": "Fire OS",
    "gid://shopify/Metaobject/131027632206": "NVIDIA GeForce RTX 3050",
    "gid://shopify/Metaobject/131049390158": "AMD Radeon ",
    "gid://shopify/Metaobject/131049848910": "VGA Intel Iris Xe ",
    "gid://shopify/Metaobject/131060236366": " Intel UHD Graphics",
    "gid://shopify/Metaobject/131060727886": "AMD Radeon Graphics",
    "gid://shopify/Metaobject/131063251022": "NVIDIA GeForce RTX 4050",
    "gid://shopify/Metaobject/131064954958": "NVIDIA GeForce RTX 4080",
    "gid://shopify/Metaobject/131065217102": "NVIDIA GeForce RTX 4090",
    "gid://shopify/Metaobject/131342467150": "NVIDIA GeForce RTX 4060",
    "gid://shopify/Metaobject/131343319118": "Intel ARC",
    "gid://shopify/Metaobject/131349774414": "NVIDIA  GeForce RTX 2050",
    "gid://shopify/Metaobject/131352035406": "AMD Radeon 780M",
    "gid://shopify/Metaobject/178964758606": "Integrated",
    "gid://shopify/Metaobject/131028615246": "DDR4",
    "gid://shopify/Metaobject/131059941454": "DDR5",
    "gid://shopify/Metaobject/131063283790": "GDDR6",
    "gid://shopify/Metaobject/131342663758": "GDDR5",
    "gid://shopify/Metaobject/131029303374": "16 GB",
    "gid://shopify/Metaobject/131049750606": "8 GB",
    "gid://shopify/Metaobject/131064627278": "32 GB",
    "gid://shopify/Metaobject/131065380942": "64 GB",
    "gid://shopify/Metaobject/131029237838": " 512",
    "gid://shopify/Metaobject/131061022798": "1 TB",
    "gid://shopify/Metaobject/131063447630": "1.024 TB",
    "gid://shopify/Metaobject/131064660046": "2 TB",
    "gid://shopify/Metaobject/131065413710": "2.048 TB",
    "gid://shopify/Metaobject/131711041614": "2 TB",
    "gid://shopify/Metaobject/131887366222": "480 GB",
    "gid://shopify/Metaobject/131887628366": "240 GB",
    "gid://shopify/Metaobject/131887857742": "120 GB",
    "gid://shopify/Metaobject/131888316494": "1 TB",
    "gid://shopify/Metaobject/131888480334": "128 GB",
    "gid://shopify/Metaobject/131889594446": "500 GB",
    "gid://shopify/Metaobject/131890348110": "256 GB",
    "gid://shopify/Metaobject/131890675790": "960 GB",
    "gid://shopify/Metaobject/131891986510": "250 GB",
    "gid://shopify/Metaobject/131893887054": "512 GB",
    "gid://shopify/Metaobject/132215177294": "6 TB",
    "gid://shopify/Metaobject/132477878350": "4 TB",
    "gid://shopify/Metaobject/132478074958": "12 TB",
    "gid://shopify/Metaobject/132573331534": "8 TB",
    "gid://shopify/Metaobject/132574085198": "10 TB",
    "gid://shopify/Metaobject/166640910414": "512 GB",
    "gid://shopify/Metaobject/166642876494": "64 GB",
    "gid://shopify/Metaobject/166643990606": "32 GB",
    "gid://shopify/Metaobject/131349839950": "PCIe/NVMe SSD",
    "gid://shopify/Metaobject/131461709902": "Socket AM4",
    "gid://shopify/Metaobject/131636887630": "Socket AM5",
    "gid://shopify/Metaobject/131638624334": "LGA 1700",
    "gid://shopify/Metaobject/131638919246": "LGA 1200",
    "gid://shopify/Metaobject/131691020366": "LGA 1851",
    "gid://shopify/Metaobject/175505932366": "LGA 1851",
    "gid://shopify/Metaobject/131710746702": "Interni",
    "gid://shopify/Metaobject/131710779470": "Eksterni",
    "gid://shopify/Metaobject/131713105998": "ATX",
    "gid://shopify/Metaobject/131713138766": "Micro - ATX",
    "gid://shopify/Metaobject/131713204302": "Mini - ITX",
    "gid://shopify/Metaobject/132148527182": "Intel",
    "gid://shopify/Metaobject/132148691022": "AMD",
    "gid://shopify/Metaobject/132213637198": "44 cm",
    "gid://shopify/Metaobject/132348411982": "37 cm",
    "gid://shopify/Metaobject/132349657166": "45 cm",
    "gid://shopify/Metaobject/132354900046": "24 cm",
    "gid://shopify/Metaobject/132355293262": "40 cm",
    "gid://shopify/Metaobject/132355850318": "39 cm",
    "gid://shopify/Metaobject/132356079694": "34 cm",
    "gid://shopify/Metaobject/132356735054": "44.5 cm",
    "gid://shopify/Metaobject/132357226574": "32 cm",
    "gid://shopify/Metaobject/132357521486": "42 cm",
    "gid://shopify/Metaobject/132358013006": "37.5 cm",
    "gid://shopify/Metaobject/132358275150": "31.5 cm",
    "gid://shopify/Metaobject/132359553102": "41 cm",
    "gid://shopify/Metaobject/132359815246": "40.7 cm",
    "gid://shopify/Metaobject/132359913550": "44.4 cm",
    "gid://shopify/Metaobject/132360077390": "36 cm",
    "gid://shopify/Metaobject/132363878478": "38 cm",
    "gid://shopify/Metaobject/132471619662": "33 cm",
    "gid://shopify/Metaobject/132472963150": "42.5 cm",
    "gid://shopify/Metaobject/132473192526": "35.5 cm",
    "gid://shopify/Metaobject/132473356366": "38.5 cm",
    "gid://shopify/Metaobject/132474732622": "33.8 cm",
    "gid://shopify/Metaobject/132214194254": "Mid Tower",
    "gid://shopify/Metaobject/132214358094": "Full Tower",
    "gid://shopify/Metaobject/132214390862": "Mini Tower",
    "gid://shopify/Metaobject/132214423630": "Small Form Factor",
    "gid://shopify/Metaobject/132359749710": "Mid tower",
    "gid://shopify/Metaobject/132595515470": "Gaming",
    "gid://shopify/Metaobject/132595548238": "Optical",
    "gid://shopify/Metaobject/179938525262": "Wireless",
    "gid://shopify/Metaobject/132595581006": "Customizable RGB lighting",
    "gid://shopify/Metaobject/132595613774": "Optical sensor",
    "gid://shopify/Metaobject/132595646542": "Scroll wheel",
    "gid://shopify/Metaobject/133099159630": "Mouse buttons",
    "gid://shopify/Metaobject/133697273934": "Condenser",
    "gid://shopify/Metaobject/133697306702": "Omnidirectional",
    "gid://shopify/Metaobject/133890474062": "Cardioid",
    "gid://shopify/Metaobject/133890506830": "3/8\"-16",
    "gid://shopify/Metaobject/133890539598": "5/8\"-27",
    "gid://shopify/Metaobject/207918661710": "Coffee beans",
    "gid://shopify/Metaobject/146225070158": "800 W",
    "gid://shopify/Metaobject/146225496142": "500 W",
    "gid://shopify/Metaobject/146241126478": "1100 W",
    "gid://shopify/Metaobject/146241912910": "1800 W",
    "gid://shopify/Metaobject/146242338894": "400 W",
    "gid://shopify/Metaobject/146242568270": "300 W",
    "gid://shopify/Metaobject/146243158094": "700 W",
    "gid://shopify/Metaobject/146243649614": "250 W",
    "gid://shopify/Metaobject/146244698190": "150 W",
    "gid://shopify/Metaobject/146245877838": "1200 W",
    "gid://shopify/Metaobject/146246598734": "200 W",
    "gid://shopify/Metaobject/146246893646": "320 W",
    "gid://shopify/Metaobject/146247155790": "900 W",
    "gid://shopify/Metaobject/146248106062": "600 W",
    "gid://shopify/Metaobject/146248335438": "450 W",
    "gid://shopify/Metaobject/146521096270": "1400 W",
    "gid://shopify/Metaobject/146522374222": "25 W",
    "gid://shopify/Metaobject/146522898510": "150 W",
    "gid://shopify/Metaobject/146913034318": "900 W",
    "gid://shopify/Metaobject/146915393614": "1000 W",
    "gid://shopify/Metaobject/146916540494": "1600 W",
    "gid://shopify/Metaobject/146918965326": "1050 W",
    "gid://shopify/Metaobject/146922045518": "1250 W",
    "gid://shopify/Metaobject/151548231758": "2000 W",
    "gid://shopify/Metaobject/151549083726": "750 W",
    "gid://shopify/Metaobject/151551180878": "2100 W",
    "gid://shopify/Metaobject/151665836110": "940 W",
    "gid://shopify/Metaobject/151666393166": "350 W",
    "gid://shopify/Metaobject/153107693646": "2200 W",
    "gid://shopify/Metaobject/153129386062": "2600 W",
    "gid://shopify/Metaobject/153133580366": "3000 W",
    "gid://shopify/Metaobject/153135185998": "2800 W",
    "gid://shopify/Metaobject/153148915790": "2500 W",
    "gid://shopify/Metaobject/153150849102": "2400 W",
    "gid://shopify/Metaobject/153191546958": "1500 W",
    "gid://shopify/Metaobject/153192169550": "1300 W",
    "gid://shopify/Metaobject/153194823758": "2980 W",
    "gid://shopify/Metaobject/153195970638": "3200 W",
    "gid://shopify/Metaobject/153196068942": "3100 W",
    "gid://shopify/Metaobject/173217448014": "2300 W",
    "gid://shopify/Metaobject/179149504590": "280 W",
    "gid://shopify/Metaobject/179152879694": "330 W",
    "gid://shopify/Metaobject/181653209166": "850 W",
    "gid://shopify/Metaobject/181655044174": "650 W",
    "gid://shopify/Metaobject/182239854670": "100 W",
    "gid://shopify/Metaobject/183303536718": "345 W",
    "gid://shopify/Metaobject/183305371726": "550 W",
    "gid://shopify/Metaobject/184948064334": "450 W",
    "gid://shopify/Metaobject/184949276750": "850 W",
    "gid://shopify/Metaobject/189553344590": "640 W",
    "gid://shopify/Metaobject/189553377358": "460 W",
    "gid://shopify/Metaobject/192473202766": "1900 W",
    "gid://shopify/Metaobject/192473759822": "2200 W",
    "gid://shopify/Metaobject/196420796494": "30 W",
    "gid://shopify/Metaobject/207037923406": "560 W",
    "gid://shopify/Metaobject/224450314318": "1100 W",
    "gid://shopify/Metaobject/146521849934": "Nema",
    "gid://shopify/Metaobject/146522243150": "2600mAh",
    "gid://shopify/Metaobject/149742813262": "180Hz",
    "gid://shopify/Metaobject/149759098958": "165Hz",
    "gid://shopify/Metaobject/150565290062": "100Hz",
    "gid://shopify/Metaobject/150565814350": "300Hz",
    "gid://shopify/Metaobject/150568370254": "60Hz",
    "gid://shopify/Metaobject/150764388430": "240Hz",
    "gid://shopify/Metaobject/150764879950": "380Hz",
    "gid://shopify/Metaobject/150765502542": "250Hz",
    "gid://shopify/Metaobject/150767403086": "480Hz",
    "gid://shopify/Metaobject/171049222222": "200Hz",
    "gid://shopify/Metaobject/171064328270": "390Hz",
    "gid://shopify/Metaobject/171064950862": "75Hz",
    "gid://shopify/Metaobject/171065770062": "120Hz",
    "gid://shopify/Metaobject/171068981326": "320Hz",
    "gid://shopify/Metaobject/183822352462": "144Hz",
    "gid://shopify/Metaobject/243447857230": "160Hz",
    "gid://shopify/Metaobject/243447922766": "540Hz",
    "gid://shopify/Metaobject/243451199566": "280Hz",
    "gid://shopify/Metaobject/246723674190": "500Hz",
    "gid://shopify/Metaobject/246723706958": "170Hz",
    "gid://shopify/Metaobject/246723739726": "360Hz",
    "gid://shopify/Metaobject/149742846030": "1 ms",
    "gid://shopify/Metaobject/150565716046": "0.5 ms",
    "gid://shopify/Metaobject/150568304718": "4 ms",
    "gid://shopify/Metaobject/150767075406": " 5 ms",
    "gid://shopify/Metaobject/150767337550": "0.3 ms",
    "gid://shopify/Metaobject/173440270414": "8 ms",
    "gid://shopify/Metaobject/173449347150": "6 ms",
    "gid://shopify/Metaobject/150915612750": "2000 Pa",
    "gid://shopify/Metaobject/151652368462": "18000 Pa",
    "gid://shopify/Metaobject/151662264398": "4000 Pa",
    "gid://shopify/Metaobject/151662854222": "6000 Pa",
    "gid://shopify/Metaobject/151664099406": "5000 Pa",
    "gid://shopify/Metaobject/151664230478": "3500 Pa",
    "gid://shopify/Metaobject/151664328782": "1400 Pa",
    "gid://shopify/Metaobject/165517262926": "7000 Pa",
    "gid://shopify/Metaobject/203025252430": "8000 Pa",
    "gid://shopify/Metaobject/210299912270": "20000 Pa",
    "gid://shopify/Metaobject/151310827598": "45 km",
    "gid://shopify/Metaobject/151665770574": "70 km",
    "gid://shopify/Metaobject/151666229326": "60 km",
    "gid://shopify/Metaobject/151666655310": "25 km",
    "gid://shopify/Metaobject/151667343438": "40 km",
    "gid://shopify/Metaobject/204790005838": "35 km",
    "gid://shopify/Metaobject/224450969678": "75 km",
    "gid://shopify/Metaobject/151310893134": "120 kg",
    "gid://shopify/Metaobject/151666688078": "90 kg",
    "gid://shopify/Metaobject/204781158478": "100 kg",
    "gid://shopify/Metaobject/224450281550": "130 kg",
    "gid://shopify/Metaobject/224451002446": "140 kg",
    "gid://shopify/Metaobject/151310925902": "25 km/h",
    "gid://shopify/Metaobject/151546888270": "Filtering",
    "gid://shopify/Metaobject/151549116494": "Cyclonic",
    "gid://shopify/Metaobject/151546921038": "Vinyl flooring",
    "gid://shopify/Metaobject/151546986574": "Wood flooring",
    "gid://shopify/Metaobject/151547052110": "Laminate flooring",
    "gid://shopify/Metaobject/151547117646": "Hard surfaces",
    "gid://shopify/Metaobject/151547150414": "Carpet",
    "gid://shopify/Metaobject/151547183182": "Tiles",
    "gid://shopify/Metaobject/151548526670": "Rug",
    "gid://shopify/Metaobject/151548559438": "Upholstery",
    "gid://shopify/Metaobject/151549149262": "Stone flooring",
    "gid://shopify/Metaobject/151551049806": "Fabric",
    "gid://shopify/Metaobject/151660724302": "Pet bedding",
    "gid://shopify/Metaobject/151546953806": "HEPA",
    "gid://shopify/Metaobject/151549182030": "Standard",
    "gid://shopify/Metaobject/151547019342": "Dust bag",
    "gid://shopify/Metaobject/151548493902": "Bagless",
    "gid://shopify/Metaobject/151547084878": "Dry",
    "gid://shopify/Metaobject/151551377486": "Dry & wet",
    "gid://shopify/Metaobject/151665999950": "Weather resistant",
    "gid://shopify/Metaobject/151666262094": "Portable",
    "gid://shopify/Metaobject/151666327630": "Lightweight",
    "gid://shopify/Metaobject/151666425934": "Anti-slip",
    "gid://shopify/Metaobject/151666753614": "Foldable",
    "gid://shopify/Metaobject/151666032718": "Inflatable",
    "gid://shopify/Metaobject/151666294862": "Solid",
    "gid://shopify/Metaobject/153107726414": "90 g/min",
    "gid://shopify/Metaobject/153129418830": "130 g/min",
    "gid://shopify/Metaobject/153129451598": "190 g/min",
    "gid://shopify/Metaobject/153133613134": "250 g/min",
    "gid://shopify/Metaobject/153134858318": "80 g/min",
    "gid://shopify/Metaobject/153135448142": "500 g/min",
    "gid://shopify/Metaobject/153137381454": "100 g/min",
    "gid://shopify/Metaobject/153138397262": "220 g/min",
    "gid://shopify/Metaobject/153144229966": "20 g/min",
    "gid://shopify/Metaobject/153144885326": "380 g/min",
    "gid://shopify/Metaobject/153145868366": "430 g/min",
    "gid://shopify/Metaobject/153146032206": "280 g/min",
    "gid://shopify/Metaobject/153148358734": "50 g/min",
    "gid://shopify/Metaobject/153150685262": "350 g/min",
    "gid://shopify/Metaobject/153150881870": "135 g/min",
    "gid://shopify/Metaobject/153191612494": "28 g/min",
    "gid://shopify/Metaobject/153192202318": "24 g/min",
    "gid://shopify/Metaobject/153192529998": "25 g/min",
    "gid://shopify/Metaobject/153193381966": "600 g/min",
    "gid://shopify/Metaobject/153193971790": "520 g/min",
    "gid://shopify/Metaobject/153195642958": "450 g/min",
    "gid://shopify/Metaobject/153196003406": "350 g/min",
    "gid://shopify/Metaobject/153196101710": "135 g/min",
    "gid://shopify/Metaobject/153196396622": "22 g/min",
    "gid://shopify/Metaobject/153196789838": "26 g/min",
    "gid://shopify/Metaobject/153197707342": "30 g/min",
    "gid://shopify/Metaobject/183440769102": "40 g/min",
    "gid://shopify/Metaobject/183442309198": "160 g/min",
    "gid://shopify/Metaobject/205730873422": "35 g/min",
    "gid://shopify/Metaobject/153148457038": "Auto power-off",
    "gid://shopify/Metaobject/153607569486": "6 GB",
    "gid://shopify/Metaobject/153642303566": "8 GB",
    "gid://shopify/Metaobject/153645449294": "4 GB",
    "gid://shopify/Metaobject/153648529486": "12 GB",
    "gid://shopify/Metaobject/153607536718": "128 GB",
    "gid://shopify/Metaobject/153642139726": "256 GB",
    "gid://shopify/Metaobject/153648463950": "512 GB",
    "gid://shopify/Metaobject/156916973646": "64 GB",
    "gid://shopify/Metaobject/153750995022": "Lithium-ion (Li-ion)",
    "gid://shopify/Metaobject/153751027790": "4G",
    "gid://shopify/Metaobject/153751126094": "3G",
    "gid://shopify/Metaobject/153751158862": "LTE",
    "gid://shopify/Metaobject/153751191630": "5G",
    "gid://shopify/Metaobject/153751060558": "Dual",
    "gid://shopify/Metaobject/153751093326": "Unlocked",
    "gid://shopify/Metaobject/157801775182": "Adults",
    "gid://shopify/Metaobject/157801906254": "Universal",
    "gid://shopify/Metaobject/157801807950": "Heart rate monitor",
    "gid://shopify/Metaobject/157801873486": "Sleep tracker",
    "gid://shopify/Metaobject/157801939022": "Waterproof",
    "gid://shopify/Metaobject/157801971790": "Fitness tracker",
    "gid://shopify/Metaobject/157801840718": "Unisex",
    "gid://shopify/Metaobject/157805215822": "EU",
    "gid://shopify/Metaobject/158522671182": "Snug fit",
    "gid://shopify/Metaobject/158522703950": "Right",
    "gid://shopify/Metaobject/158522900558": "Left",
    "gid://shopify/Metaobject/158522736718": "Back cover",
    "gid://shopify/Metaobject/158523424846": "Thermoplastic polyurethane (TPU)",
    "gid://shopify/Metaobject/158523457614": "Plastic",
    "gid://shopify/Metaobject/158559567950": "PlayStation 5",
    "gid://shopify/Metaobject/158582833230": "PlayStation 4",
    "gid://shopify/Metaobject/158559600718": "18",
    "gid://shopify/Metaobject/158582636622": "3",
    "gid://shopify/Metaobject/158617567310": "7",
    "gid://shopify/Metaobject/158622908494": "16",
    "gid://shopify/Metaobject/158623694926": "12",
    "gid://shopify/Metaobject/158559666254": "Europe (EU)",
    "gid://shopify/Metaobject/158938398798": "North America (NA)",
    "gid://shopify/Metaobject/158559633486": "18",
    "gid://shopify/Metaobject/158582603854": "3",
    "gid://shopify/Metaobject/158617534542": "7",
    "gid://shopify/Metaobject/158623006798": "16",
    "gid://shopify/Metaobject/158623662158": "12",
    "gid://shopify/Metaobject/158559699022": "Physical",
    "gid://shopify/Metaobject/158883971150": "Digital",
    "gid://shopify/Metaobject/158559731790": "M (Mature)",
    "gid://shopify/Metaobject/158582571086": "E10+ (Everyone 10 and older)",
    "gid://shopify/Metaobject/158937579598": "T (Teen)",
    "gid://shopify/Metaobject/158559764558": "Action",
    "gid://shopify/Metaobject/158582702158": "Sports",
    "gid://shopify/Metaobject/158585126990": "Simulation",
    "gid://shopify/Metaobject/158585159758": "Adventure",
    "gid://shopify/Metaobject/158585192526": "RPG",
    "gid://shopify/Metaobject/158585815118": "Driving/Racing",
    "gid://shopify/Metaobject/158623629390": "Horror",
    "gid://shopify/Metaobject/158624088142": "Survival",
    "gid://shopify/Metaobject/158624251982": "Shooter",
    "gid://shopify/Metaobject/158789599310": "Strategy",
    "gid://shopify/Metaobject/158789632078": "Party",
    "gid://shopify/Metaobject/158810865742": "Family",
    "gid://shopify/Metaobject/158934564942": "Fighting",
    "gid://shopify/Metaobject/158582669390": "Sports management",
    "gid://shopify/Metaobject/158585487438": "Hack and slash",
    "gid://shopify/Metaobject/158585716814": "Sandbox",
    "gid://shopify/Metaobject/158622875726": "Platformer",
    "gid://shopify/Metaobject/158624120910": "Vehicle simulation",
    "gid://shopify/Metaobject/158624284750": "First-person shooter",
    "gid://shopify/Metaobject/158884069454": "Tactical shooter",
    "gid://shopify/Metaobject/158933024846": "Third-person shooter",
    "gid://shopify/Metaobject/163534307406": "High",
    "gid://shopify/Metaobject/163534340174": "Low",
    "gid://shopify/Metaobject/163534372942": "Medium",
    "gid://shopify/Metaobject/193241088078": "Ceramic",
    "gid://shopify/Metaobject/163700113486": "12 GB",
    "gid://shopify/Metaobject/163778297934": "16 GB",
    "gid://shopify/Metaobject/163778887758": "8 GB",
    "gid://shopify/Metaobject/163783606350": "32 GB",
    "gid://shopify/Metaobject/163786752078": "6 GB",
    "gid://shopify/Metaobject/163787505742": "4 GB",
    "gid://shopify/Metaobject/163781902414": "4K ultra HD",
    "gid://shopify/Metaobject/163781935182": "8K ultra HD",
    "gid://shopify/Metaobject/163781869646": "Internal",
    "gid://shopify/Metaobject/163877683278": "3.1",
    "gid://shopify/Metaobject/163878305870": "2.1",
    "gid://shopify/Metaobject/163879419982": "2",
    "gid://shopify/Metaobject/163877716046": "Smart",
    "gid://shopify/Metaobject/163877814350": "Dynamic",
    "gid://shopify/Metaobject/163877847118": "Volume control",
    "gid://shopify/Metaobject/163877912654": "Voice control",
    "gid://shopify/Metaobject/163878273102": "Subwoofer",
    "gid://shopify/Metaobject/199343341646": "Weather resistant",
    "gid://shopify/Metaobject/164232953934": "Halogen",
    "gid://shopify/Metaobject/164233052238": "Ceramic",
    "gid://shopify/Metaobject/164233117774": "Induction",
    "gid://shopify/Metaobject/164233150542": "Gas",
    "gid://shopify/Metaobject/164233838670": "Sealed plate",
    "gid://shopify/Metaobject/164232921166": "Teflon",
    "gid://shopify/Metaobject/164233085006": "Carbon steel",
    "gid://shopify/Metaobject/164233805902": "Aluminum",
    "gid://shopify/Metaobject/164233019470": "Round",
    "gid://shopify/Metaobject/164660150350": "Rectangular",
    "gid://shopify/Metaobject/164232986702": "Hand wash only",
    "gid://shopify/Metaobject/164470882382": "PlayStation 4",
    "gid://shopify/Metaobject/164470915150": "PlayStation 5",
    "gid://shopify/Metaobject/164668407886": "PlayStation 3",
    "gid://shopify/Metaobject/164668702798": "Xbox",
    "gid://shopify/Metaobject/181272838222": "PC",
    "gid://shopify/Metaobject/164660215886": "Suitable for gaming",
    "gid://shopify/Metaobject/166790594638": "Omnidirectional",
    "gid://shopify/Metaobject/166790692942": "Boom",
    "gid://shopify/Metaobject/166796787790": "Built-in",
    "gid://shopify/Metaobject/166797475918": "Noise-canceling",
    "gid://shopify/Metaobject/179935739982": "Unidirectional",
    "gid://shopify/Metaobject/166790627406": "USB",
    "gid://shopify/Metaobject/166796820558": "Bluetooth",
    "gid://shopify/Metaobject/166796853326": "3.5 mm",
    "gid://shopify/Metaobject/166790660174": "Closed-back",
    "gid://shopify/Metaobject/173059637326": "Noise cancellation",
    "gid://shopify/Metaobject/173059670094": "Built-in microphone",
    "gid://shopify/Metaobject/173059702862": "High fidelity audio",
    "gid://shopify/Metaobject/175057961038": "Volume control",
    "gid://shopify/Metaobject/170386522190": "Print",
    "gid://shopify/Metaobject/170386587726": "Copy",
    "gid://shopify/Metaobject/170386620494": "Scan",
    "gid://shopify/Metaobject/170386554958": "Inkjet",
    "gid://shopify/Metaobject/171432935502": "4K ultra HD",
    "gid://shopify/Metaobject/172343525454": "Front-load",
    "gid://shopify/Metaobject/172343558222": "Cotton",
    "gid://shopify/Metaobject/172343590990": "Wool",
    "gid://shopify/Metaobject/172343623758": "Quick wash",
    "gid://shopify/Metaobject/172343656526": "Eco",
    "gid://shopify/Metaobject/172343689294": "Intensive",
    "gid://shopify/Metaobject/172343722062": "Delicate",
    "gid://shopify/Metaobject/178185896014": "Pre-wash",
    "gid://shopify/Metaobject/207043035214": "Spin & drain",
    "gid://shopify/Metaobject/173212303438": "Adjustable thermostat",
    "gid://shopify/Metaobject/173212336206": "Cool shot function",
    "gid://shopify/Metaobject/173212368974": "Diffuser nozzle",
    "gid://shopify/Metaobject/183817273422": "Concentrator nozzle",
    "gid://shopify/Metaobject/193234632782": "Ionic function",
    "gid://shopify/Metaobject/193234665550": "Ceramic heating system",
    "gid://shopify/Metaobject/193234698318": "Auto power-off",
    "gid://shopify/Metaobject/173357531214": "80 PLUS Gold",
    "gid://shopify/Metaobject/181653930062": "80 PLUS Bronze",
    "gid://shopify/Metaobject/184946065486": "80 PLUS Silver",
    "gid://shopify/Metaobject/182515892302": "Ceramic",
    "gid://shopify/Metaobject/211337478222": "Glass-ceramic",
    "gid://shopify/Metaobject/186182533198": "Dolby atmos",
    "gid://shopify/Metaobject/186182565966": "DTS-X",
    "gid://shopify/Metaobject/211338231886": "DTS",
    "gid://shopify/Metaobject/193234731086": "Ceramic",
    "gid://shopify/Metaobject/211281018958": "Touch",
    "gid://shopify/Metaobject/211281313870": "Rotary",
    "gid://shopify/Metaobject/204450562126": "Matte",
    "gid://shopify/Metaobject/208400941134": "Satin",
    "gid://shopify/Metaobject/204450627662": "Bottom freezer",
    "gid://shopify/Metaobject/208400646222": "Top freezer",
    "gid://shopify/Metaobject/207919284302": "Steam wand",
    "gid://shopify/Metaobject/207920693326": "Automatic milk frother",
    "gid://shopify/Metaobject/207919939662": "Manual",
    "gid://shopify/Metaobject/207920496718": "Automatic",
    "gid://shopify/Metaobject/207920562254": "Automatic",
    "gid://shopify/Metaobject/211281870926": "Semi-automatic",
    "gid://shopify/Metaobject/207920726094": "Thermoblock",
    "gid://shopify/Metaobject/207921446990": "Stainless steel",
    "gid://shopify/Metaobject/207921479758": "Coarse",
    "gid://shopify/Metaobject/207921545294": "Medium",
    "gid://shopify/Metaobject/207921578062": "Fine",
    "gid://shopify/Metaobject/207921512526": "Burr",
    "gid://shopify/Metaobject/208403497038": "Upright",
    "gid://shopify/Metaobject/208404283470": "400 x 200 mm",
    "gid://shopify/Metaobject/211337871438": "200 x 200 mm",
    "gid://shopify/Metaobject/211338297422": "600 x 400 mm",
    "gid://shopify/Metaobject/211338264654": "30000000:1",
    "gid://shopify/Metaobject/211339018318": "Stainless steel",
    "gid://shopify/Metaobject/211339051086": "Plastic",
    "gid://shopify/Metaobject/211340165198": "Multiple",
    "gid://shopify/Metaobject/211759890510": "Built-in battery",
    "gid://shopify/Metaobject/211759923278": "Rechargeable",
    "gid://shopify/Metaobject/218056622158": "Digitalni",
    "gid://shopify/Metaobject/218056720462": "Zvučni alarmi",
    "gid://shopify/Metaobject/218056785998": "Vizualna upozorenja",
    "gid://shopify/Metaobject/218056687694": "Digitalni",
    "gid://shopify/Metaobject/218056654926": "Stolni",
    "gid://shopify/Metaobject/218056753230": "Digitalne znamenke",
    "gid://shopify/Metaobject/241299718222": "Description",
    "gid://shopify/Metaobject/241299750990": "Target audience",
    "gid://shopify/Metaobject/241299783758": "Tags",
    "gid://shopify/Metaobject/241299816526": "Sample queries",
    "gid://shopify/Metaobject/241299849294": "Tagline",
    "gid://shopify/Metaobject/241299882062": "Predominant colours",
    "gid://shopify/Metaobject/241299914830": "Brand values",
    "gid://shopify/Metaobject/241299947598": "Brand aesthetic",
    "gid://shopify/Metaobject/241299980366": "Brand tone of voice",
    "gid://shopify/Metaobject/241300013134": "Targeted lifestyles",
    "gid://shopify/Metaobject/241300045902": "Customer relationship model",
    "gid://shopify/Metaobject/241300078670": "Emotional appeal category",
    "gid://shopify/Metaobject/241300111438": "Main brands",
    "gid://shopify/Metaobject/241300176974": "Owner operated",
    "gid://shopify/Metaobject/241300209742": "Start year",
    "gid://shopify/Metaobject/241300275278": "Social angle",
    "gid://shopify/Metaobject/241300308046": "Is second hand",
    "gid://shopify/Metaobject/241300340814": "International available",
    "gid://shopify/Metaobject/241300373582": "Express available",
    "gid://shopify/Metaobject/241300406350": "Store pickup available",
    "gid://shopify/Metaobject/241300439118": "Lost package policy",
    "gid://shopify/Metaobject/241300471886": "Late delivery policy",
    "gid://shopify/Metaobject/241300504654": "Return policy",
    "gid://shopify/Metaobject/241300537422": "Restocking fee exists",
    "gid://shopify/Metaobject/241300570190": "Return timeframe",
    "gid://shopify/Metaobject/241300602958": "Return conditions",
    "gid://shopify/Metaobject/241300635726": "Refund method",
    "gid://shopify/Metaobject/241300668494": "Return process",
    "gid://shopify/Metaobject/241300701262": "Warranty info",
    "gid://shopify/Metaobject/241300734030": "Repair services available",
    "gid://shopify/Metaobject/241300766798": "Warranty duration",
    "gid://shopify/Metaobject/241300799566": "Warranty coverage",
    "gid://shopify/Metaobject/241300832334": "Claim process",
    "gid://shopify/Metaobject/241300865102": "Phone ordering available",
    "gid://shopify/Metaobject/241300897870": "Order modification policy",
    "gid://shopify/Metaobject/241300930638": "Order tracking available",
    "gid://shopify/Metaobject/241300963406": "Social media instagram",
    "gid://shopify/Metaobject/241300996174": "Social media facebook",
    "gid://shopify/Metaobject/241301028942": "Social media twitter",
    "gid://shopify/Metaobject/241301061710": "Social media tiktok",
    "gid://shopify/Metaobject/241301094478": "Social media youtube",
    "gid://shopify/Metaobject/241301127246": "Social media pinterest",
    "gid://shopify/Metaobject/241301160014": "Social media linkedin",
    "gid://shopify/Metaobject/241301192782": "Contact methods",
    "gid://shopify/Metaobject/241301225550": "Gift wrapping available",
    "gid://shopify/Metaobject/241301258318": "Gift receipts available",
    "gid://shopify/Metaobject/241301291086": "Gift cards available",
    "gid://shopify/Metaobject/241301323854": "Gift card balance check method",
    "gid://shopify/Metaobject/241301356622": "Bridal registry available"
};
    this.filterNames = {
    "shopify--device-interface": "Display port",
    "Device_interface": "Display port",
    "shopify--speaker-design": "Portable",
    "Speaker_design": "Portable",
    "shopify--color-pattern": "Blue",
    "Color_pattern": "Blue",
    "shopify--connectivity-technology": "Radio",
    "Connectivity_technology": "Radio",
    "shopify--audio-purpose": "Outdoor use",
    "Audio_purpose": "Outdoor use",
    "shopify--material": "Silicone",
    "Material": "Silicone",
    "shopify--energy-efficiency-class": "G",
    "Energy_efficiency_class": "G",
    "shopify--display-technology": "ULED",
    "Display_technology": "ULED",
    "shopify--smart-tv-platform": "Google TV",
    "Smart_tv_platform": "Google TV",
    "shopify--display-resolution": "Ostalo",
    "Display_resolution": "Ostalo",
    "shopify--television-specialized-features": "VESA mounting support",
    "Television_specialized_features": "VESA mounting support",
    "shopify--mounting-type": "Portable",
    "Mounting_type": "Portable",
    "sirina": "109cm",
    "Sirina": "109cm",
    "visina": "185.6cm",
    "Visina": "185.6cm",
    "garancija": "4+",
    "Garancija": "4+",
    "broj_setova": "11",
    "Broj_setova": "11",
    "broj_programa": "10+",
    "Broj_programa": "10+",
    "vrsta": "Membranska",
    "Vrsta": "Membranska",
    "broj_polja": "3",
    "Broj_polja": "3",
    "vrsta_plo_e": "Plinska",
    "Vrsta_plo_e": "Plinska",
    "zapremina": "324L",
    "Zapremina": "324L",
    "broj_obrtaja": "1300",
    "Broj_obrtaja": "1300",
    "kapacitet_pranja": "12",
    "Kapacitet_pranja": "12",
    "kapacitet_susenja": "4",
    "Kapacitet_susenja": "4",
    "dubina": "59.5cm",
    "Dubina": "59.5cm",
    "energetska_klasa_hla_enja": "A+++",
    "Energetska_klasa_hla_enja": "A+++",
    "energetska_klasa_grijanja": "A+++",
    "Energetska_klasa_grijanja": "A+++",
    "inverter": "Da",
    "Inverter": "Da",
    "snaga_hla_enja": "5.4kW",
    "Snaga_hla_enja": "5.4kW",
    "snaga_grijanja": "6.7kW",
    "Snaga_grijanja": "6.7kW",
    "shopify--power-source": "DC-powered",
    "Power_source": "DC-powered",
    "shopify--oven-accessories-included": "Wire rack",
    "Oven_accessories_included": "Wire rack",
    "shopify--energy-efficiency-class-hdr": "G",
    "Energy_efficiency_class_hdr": "G",
    "shopify--native-aspect-ratio": "16:9",
    "Native_aspect_ratio": "16:9",
    "shopify--energy-efficiency-class-sdr": "E",
    "Energy_efficiency_class_sdr": "E",
    "shopify--connection-type": "USB",
    "Connection_type": "USB",
    "shopify--hdr-format": "Dolby vision",
    "Hdr_format": "Dolby vision",
    "velicina_ekrana": "70\"",
    "Velicina_ekrana": "70\"",
    "maksimalna_dijagonala": "60",
    "Maksimalna_dijagonala": "60",
    "shopify--processor-family": "AMD Ryzen 7 5825U",
    "Processor_family": "AMD Ryzen 7 5825U",
    "shopify--operating-system": "Fire OS",
    "Operating_system": "Fire OS",
    "shopify--graphics-card-type": "Integrated",
    "Graphics_card_type": "Integrated",
    "shopify--memory-technology": "GDDR5",
    "Memory_technology": "GDDR5",
    "kapacitet_radne_memorije": "64",
    "Kapacitet_radne_memorije": "64",
    "kapacitet_ssd": "32 GB",
    "Kapacitet_ssd": "32 GB",
    "shopify--storage-types-supported": "PCIe/NVMe SSD",
    "Storage_types_supported": "PCIe/NVMe SSD",
    "shopify--processor-socket": "LGA 1851",
    "Processor_socket": "LGA 1851",
    "shopify--hard-drive-installation": "Eksterni",
    "Hard_drive_installation": "Eksterni",
    "shopify--circuit-board-features": "Mini - ITX",
    "Circuit_board_features": "Mini - ITX",
    "shopify--motherboard-chipset-family": "AMD",
    "Motherboard_chipset_family": "AMD",
    "maksimalna_velicina_graficke_kartice": "33.8",
    "Maksimalna_velicina_graficke_kartice": "33.8",
    "velicina": "Small Form Factor",
    "Velicina": "Small Form Factor",
    "shopify--chassis-type": "Mid tower",
    "Chassis_type": "Mid tower",
    "shopify--mouse-technology": "Wireless",
    "Mouse_technology": "Wireless",
    "shopify--mouse-trackball-features": "Scroll wheel",
    "Mouse_trackball_features": "Scroll wheel",
    "shopify--pointing-device": "Mouse buttons",
    "Pointing_device": "Mouse buttons",
    "shopify--microphone-design": "Condenser",
    "Microphone_design": "Condenser",
    "shopify--polar-pattern": "Cardioid",
    "Polar_pattern": "Cardioid",
    "shopify--microphone-thread": "5/8\"-27",
    "Microphone_thread": "5/8\"-27",
    "shopify--coffee-input-type": "Coffee beans",
    "Coffee_input_type": "Coffee beans",
    "snaga": "1100",
    "Snaga": "1100",
    "baterija": "2600mAh",
    "Baterija": "2600mAh",
    "refresh_rate": "360Hz",
    "Refresh_rate": "360Hz",
    "odziv": "6 ms",
    "Odziv": "6 ms",
    "snaga_pa": "20000",
    "Snaga_pa": "20000",
    "domet_km": "75",
    "Domet_km": "75",
    "nosivost": "140",
    "Nosivost": "140",
    "maksimalna_brzina": "25",
    "Maksimalna_brzina": "25",
    "shopify--dirt-separating-method": "Cyclonic",
    "Dirt_separating_method": "Cyclonic",
    "shopify--cleaning-surfaces": "Pet bedding",
    "Cleaning_surfaces": "Pet bedding",
    "shopify--vacuum-air-filtering-technology": "Standard",
    "Vacuum_air_filtering_technology": "Standard",
    "shopify--dust-container-type": "Bagless",
    "Dust_container_type": "Bagless",
    "shopify--dry-wet-cleaning": "Dry & wet",
    "Dry_wet_cleaning": "Dry & wet",
    "shopify--features": "Foldable",
    "Features": "Foldable",
    "shopify--wheel-type": "Solid",
    "Wheel_type": "Solid",
    "udar_pare_g_min": "35",
    "Udar_pare_g_min": "35",
    "shopify--ironing-features": "Auto power-off",
    "Ironing_features": "Auto power-off",
    "ram_memorija": "12",
    "Ram_memorija": "12",
    "interna_memorija": "64",
    "Interna_memorija": "64",
    "shopify--battery-technology": "Lithium-ion (Li-ion)",
    "Battery_technology": "Lithium-ion (Li-ion)",
    "shopify--data-network": "5G",
    "Data_network": "5G",
    "shopify--sim-card-capability": "Dual",
    "Sim_card_capability": "Dual",
    "shopify--subscription-type": "Unlocked",
    "Subscription_type": "Unlocked",
    "shopify--age-group": "Universal",
    "Age_group": "Universal",
    "shopify--smart-watch-features": "Fitness tracker",
    "Smart_watch_features": "Fitness tracker",
    "shopify--target-gender": "Unisex",
    "Target_gender": "Unisex",
    "shopify--plug-type": "EU",
    "Plug_type": "EU",
    "shopify--mobile-phone-case-features": "Snug fit",
    "Mobile_phone_case_features": "Snug fit",
    "shopify--hand-side": "Left",
    "Hand_side": "Left",
    "shopify--case-type": "Back cover",
    "Case_type": "Back cover",
    "shopify--bag-case-material": "Plastic",
    "Bag_case_material": "Plastic",
    "shopify--video-game-platform": "PlayStation 4",
    "Video_game_platform": "PlayStation 4",
    "shopify--national-regional-rating": "12",
    "National_regional_rating": "12",
    "shopify--region-code": "North America (NA)",
    "Region_code": "North America (NA)",
    "shopify--pegi-rating": "12",
    "Pegi_rating": "12",
    "shopify--video-game-format": "Digital",
    "Video_game_format": "Digital",
    "shopify--esrb-rating": "T (Teen)",
    "Esrb_rating": "T (Teen)",
    "shopify--video-game-genre": "Fighting",
    "Video_game_genre": "Fighting",
    "shopify--video-game-sub-genre": "Third-person shooter",
    "Video_game_sub_genre": "Third-person shooter",
    "shopify--heat-settings": "Medium",
    "Heat_settings": "Medium",
    "shopify--plate-type": "Ceramic",
    "Plate_type": "Ceramic",
    "vram_gb": "4",
    "Vram_gb": "4",
    "shopify--video-resolution-supported": "8K ultra HD",
    "Video_resolution_supported": "8K ultra HD",
    "shopify--card-adapter-installation": "Internal",
    "Card_adapter_installation": "Internal",
    "shopify--audio-output-channel": "2",
    "Audio_output_channel": "2",
    "shopify--speaker-technology": "Dynamic",
    "Speaker_technology": "Dynamic",
    "shopify--speaker-features": "Weather resistant",
    "Speaker_features": "Weather resistant",
    "shopify--compatible-stove-top-type": "Sealed plate",
    "Compatible_stove_top_type": "Sealed plate",
    "shopify--cookware-bakeware-material": "Aluminum",
    "Cookware_bakeware_material": "Aluminum",
    "shopify--shape": "Rectangular",
    "Shape": "Rectangular",
    "shopify--cleaning-instructions": "Hand wash only",
    "Cleaning_instructions": "Hand wash only",
    "shopify--console-system": "PC",
    "Console_system": "PC",
    "shopify--mouse-pad-features": "Suitable for gaming",
    "Mouse_pad_features": "Suitable for gaming",
    "shopify--microphone-type": "Unidirectional",
    "Microphone_type": "Unidirectional",
    "shopify--audio-connectivity": "3.5 mm",
    "Audio_connectivity": "3.5 mm",
    "shopify--headphone-style": "Closed-back",
    "Headphone_style": "Closed-back",
    "shopify--earphone-features": "Volume control",
    "Earphone_features": "Volume control",
    "shopify--printer-functions": "Scan",
    "Printer_functions": "Scan",
    "shopify--print-technology": "Inkjet",
    "Print_technology": "Inkjet",
    "shopify--compatible-resolution": "4K ultra HD",
    "Compatible_resolution": "4K ultra HD",
    "shopify--loading-type": "Front-load",
    "Loading_type": "Front-load",
    "shopify--washing-programs": "Spin & drain",
    "Washing_programs": "Spin & drain",
    "shopify--hair-styling-tool-features": "Auto power-off",
    "Hair_styling_tool_features": "Auto power-off",
    "efikasnost": "80 PLUS Silver",
    "Efikasnost": "80 PLUS Silver",
    "shopify--top-surface-material": "Glass-ceramic",
    "Top_surface_material": "Glass-ceramic",
    "shopify--audio-technology": "DTS",
    "Audio_technology": "DTS",
    "shopify--barrel-material": "Ceramic",
    "Barrel_material": "Ceramic",
    "shopify--control-type": "Rotary",
    "Control_type": "Rotary",
    "shopify--finish": "Satin",
    "Finish": "Satin",
    "shopify--refrigerator-configuration": "Top freezer",
    "Refrigerator_configuration": "Top freezer",
    "shopify--milk-frothing-system": "Automatic milk frother",
    "Milk_frothing_system": "Automatic milk frother",
    "shopify--automation": "Semi-automatic",
    "Automation": "Semi-automatic",
    "shopify--espresso-boiler-type": "Thermoblock",
    "Espresso_boiler_type": "Thermoblock",
    "shopify--grinding-mechanism-material": "Stainless steel",
    "Grinding_mechanism_material": "Stainless steel",
    "shopify--grind-size": "Fine",
    "Grind_size": "Fine",
    "shopify--grinding-mechanism-type": "Burr",
    "Grinding_mechanism_type": "Burr",
    "shopify--freezer-configuration": "Upright",
    "Freezer_configuration": "Upright",
    "shopify--vesa-mounting-pattern": "600 x 400 mm",
    "Vesa_mounting_pattern": "600 x 400 mm",
    "shopify--contrast-ratio-typical": "30000000:1",
    "Contrast_ratio_typical": "30000000:1",
    "shopify--blade-material": "Stainless steel",
    "Blade_material": "Stainless steel",
    "shopify--blender-jar-material": "Plastic",
    "Blender_jar_material": "Plastic",
    "shopify--speed-settings": "Multiple",
    "Speed_settings": "Multiple",
    "shopify--battery-size": "Built-in battery",
    "Battery_size": "Built-in battery",
    "shopify--battery-type": "Rechargeable",
    "Battery_type": "Rechargeable",
    "shopify--clock-movement-type": "Digitalni",
    "Clock_movement_type": "Digitalni",
    "shopify--alert-type": "Vizualna upozorenja",
    "Alert_type": "Vizualna upozorenja",
    "shopify--display-mode": "Digitalni",
    "Display_mode": "Digitalni",
    "shopify--stand-display-type": "Stolni",
    "Stand_display_type": "Stolni",
    "shopify--numeral-style": "Digitalne znamenke",
    "Numeral_style": "Digitalne znamenke",
    "shopify--knowledge-base-fact": "Bridal registry available",
    "Knowledge_base_fact": "Bridal registry available"
};
    this.nativeFacetCounts = new Map();
    this.collectionHandle = this.getCollectionHandle();
    this.allProductsData = [];
    this.allProductsLoaded = false;
    this.init();
  }

  getCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^\/]+)/);
    return match ? match[1] : null;
  }

  init() {
    // Check if we have custom filters in URL while on page > 1
    // If so, redirect to page 1 to ensure all products can be loaded
    const urlParams = new URLSearchParams(window.location.search);
    const hasCustomFilters = Array.from(urlParams.keys()).some(k => k.startsWith('filter.p.m.custom.'));
    const currentPage = urlParams.get('page');
    
    if (hasCustomFilters && currentPage && parseInt(currentPage) > 1) {
      urlParams.delete('page');
      const newUrl = window.location.pathname + '?' + urlParams.toString();
      window.location.replace(newUrl);
      return;
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => this.setup(), 500);
      });
    } else {
      setTimeout(() => this.setup(), 500);
    }
    this.patchFacetFiltersForm();
  }
  
  patchFacetFiltersForm() {
    setTimeout(() => {
      if (typeof FacetFiltersForm !== 'undefined') {
        const originalRenderProductCount = FacetFiltersForm.renderProductCount;
        FacetFiltersForm.renderProductCount = function(html) {
          try {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const productCount = parsed.getElementById('ProductCount');
            if (productCount) {
              originalRenderProductCount.call(this, html);
            }
          } catch (e) {}
        };
      }
    }, 100);
  }

  setup() {
    this.storeAllProducts();
    this.originalProducts = [...this.allProducts]; // Keep original for restoration
    this.parseActiveFiltersFromURL();
    this.syncNativeFiltersFromURL(); // Sync native filter checkboxes with URL
    this.setupMetaobjectFilterListeners();
    this.setupNativeFilterListeners();
    this.overrideFormSubmission();
    this.updateFilterCheckboxText();
    
    // Load all products data first, then apply filtering
    this.loadAllProductsData().then(() => {
      this.updateAllCounts();
      
      if (this.activeFilters.size > 0) {
        // Custom filters active - switch to client-side mode with all products
        this.isClientFiltering = true;
        this.renderAllFilteredProducts();
        setTimeout(() => this.refreshActiveFacets(), 500);
      } else {
        this.allProducts.forEach(p => p.setAttribute('data-metaobject-visible', 'true'));
      }
    });
  }
  
  syncNativeFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Sync vendor filter checkboxes
    const vendorValues = urlParams.getAll('filter.p.vendor');
    document.querySelectorAll('input[data-haust-filter="vendor"]').forEach(input => {
      const value = input.dataset.haustValue || input.value;
      input.checked = vendorValues.includes(value);
    });
    
    // Sync availability filter checkboxes
    const availabilityValues = urlParams.getAll('filter.v.availability');
    document.querySelectorAll('input[data-haust-filter="availability"]').forEach(input => {
      const value = input.dataset.haustValue || input.value;
      input.checked = availabilityValues.includes(value);
    });
    
    // Sync product_type filter checkboxes
    const productTypeValues = urlParams.getAll('filter.p.product_type');
    document.querySelectorAll('input[data-haust-filter="product_type"]').forEach(input => {
      const value = input.dataset.haustValue || input.value;
      input.checked = productTypeValues.includes(value);
    });
    
    // Sync price filter inputs
    const priceMin = urlParams.get('filter.v.price.gte');
    const priceMax = urlParams.get('filter.v.price.lte');
    const minInput = document.querySelector('[data-haust-price-min]');
    const maxInput = document.querySelector('[data-haust-price-max]');
    
    if (minInput && priceMin) {
      minInput.value = parseFloat(priceMin) / 100; // Convert from cents
    }
    if (maxInput && priceMax) {
      maxInput.value = parseFloat(priceMax) / 100;
    }
  }

  async loadAllProductsData() {
    if (this.allProductsLoaded || !this.collectionHandle) {
      return;
    }
    try {
      const jsonUrl = `/collections/${this.collectionHandle}?view=json-data`;
      const response = await fetch(jsonUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch product data: ${response.statusText}`);
      }
      this.allProductsData = await response.json();
      this.allProductsLoaded = true;
    } catch (error) {
      this.allProductsLoaded = false;
    }
  }

  updateFilterCheckboxText() {
    document.querySelectorAll('[data-gid]').forEach(element => {
      const gid = element.getAttribute('data-gid');
      const displayText = this.displayValues[gid];
      
      if (displayText) {
        const textLabel = element.querySelector('.facet-checkbox__text-label');
        if (textLabel) {
          const currentText = textLabel.textContent;
          const countMatch = currentText.match(/\((\d+)\)$/);
          const count = countMatch ? countMatch[1] : '';
          textLabel.textContent = displayText;
          
          const parentSpan = element.closest('.facet-checkbox__text');
          if (parentSpan && count) {
            parentSpan.innerHTML = `<span class="facet-checkbox__text-label">${displayText}</span> (${count})`;
          }
        }
      }
    });
  }

  overrideFormSubmission() {
    const facetForm = document.getElementById('FacetFiltersForm');
    if (facetForm) {
      facetForm.addEventListener('submit', (event) => {
        const formData = new FormData(facetForm);
        for (let [key] of formData.entries()) {
          if (key.startsWith('filter.p.m.custom.')) {
            event.preventDefault();
            return false;
          }
        }
      }, true);
    }
  }

  storeAllProducts() {
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      this.allProducts = Array.from(productGrid.children);
    }
  }

  parseActiveFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const typeToValues = new Map();
    for (let [key, value] of urlParams.entries()) {
      if (!key.startsWith('filter.p.m.custom.')) continue;
      const filterType = key.replace('filter.p.m.custom.', '');
      if (!typeToValues.has(filterType)) typeToValues.set(filterType, new Set());
      typeToValues.get(filterType).add(value);
    }
    this.activeFilters = typeToValues;
    this.updateCheckboxStates();
    this.refreshActiveFacets();
  }

  setupNativeFilterListeners() {
    // Listen for native filter changes (vendor, availability, product_type, price)
    document.addEventListener('change', (event) => {
      const input = event.target;
      
      // Check if it's a native filter (has data-haust-filter but NOT data-metaobject-filter)
      if (input.hasAttribute('data-haust-filter') && !input.hasAttribute('data-metaobject-filter')) {
        event.preventDefault();
        
        const filterType = input.dataset.haustFilter;
        const filterParam = input.dataset.filterParam || input.name;
        const filterValue = input.dataset.haustValue || input.value;
        
        // Build the new URL with the filter
        const url = new URL(window.location.href);
        
        // Remove page parameter when filters change
        url.searchParams.delete('page');
        
        if (filterType === 'price') {
          // Price filter - handled separately
          return;
        }
        
        if (input.checked) {
          // Add the filter value
          if (!url.searchParams.has(filterParam) || 
              !url.searchParams.getAll(filterParam).includes(filterValue)) {
            url.searchParams.append(filterParam, filterValue);
          }
        } else {
          // Remove the filter value
          const values = url.searchParams.getAll(filterParam);
          url.searchParams.delete(filterParam);
          values.filter(v => v !== filterValue).forEach(v => {
            url.searchParams.append(filterParam, v);
          });
        }
        
        // Navigate to the new URL (causes page reload with filter applied)
        window.location.href = url.toString();
        return;
      }
    });
    
    // Handle price filter changes
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (input.hasAttribute('data-haust-price-min') || input.hasAttribute('data-haust-price-max')) {
        // Debounce price filter
        clearTimeout(this.priceDebounce);
        this.priceDebounce = setTimeout(() => {
          this.applyPriceFilter();
        }, 500);
      }
    });
  }
  
  applyPriceFilter() {
    const minInput = document.querySelector('[data-haust-price-min]');
    const maxInput = document.querySelector('[data-haust-price-max]');
    
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    
    // Remove existing price filters
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    
    // Add new price filters if values exist
    if (minInput && minInput.value) {
      // Convert to cents/smallest currency unit if needed
      const minPrice = parseFloat(minInput.value) * 100;
      url.searchParams.set('filter.v.price.gte', minPrice);
    }
    if (maxInput && maxInput.value) {
      const maxPrice = parseFloat(maxInput.value) * 100;
      url.searchParams.set('filter.v.price.lte', maxPrice);
    }
    
    // Only navigate if at least one price value is set
    if ((minInput && minInput.value) || (maxInput && maxInput.value)) {
      window.location.href = url.toString();
    }
  }

  setupMetaobjectFilterListeners() {
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (input.hasAttribute('data-metaobject-filter')) {
        event.preventDefault();
        if (this.isProcessing) return false;
        
        this.isProcessing = true;
        const filterType = input.dataset.metaobjectFilter;
        const filterValue = input.value;
        
        if (input.checked) {
          if (!this.activeFilters.has(filterType)) {
            this.activeFilters.set(filterType, new Set());
          }
          this.activeFilters.get(filterType).add(filterValue);
        } else {
          if (this.activeFilters.has(filterType)) {
            this.activeFilters.get(filterType).delete(filterValue);
            if (this.activeFilters.get(filterType).size === 0) {
              this.activeFilters.delete(filterType);
            }
          }
        }
        
        this.applyFiltering();
        this.updateURL();
        this.refreshActiveFacets();
        this.updateFilterCheckboxText();
        
        setTimeout(() => { this.isProcessing = false; }, 100);
        return false;
      }
    }, true);

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="filter.p.m.custom."]');
      if (link) {
        event.preventDefault();
        const url = new URL(link.href, window.location.origin);
        
        // Rebuild activeFilters from link URL
        const newFilters = new Map();
        for (let [key, value] of url.searchParams.entries()) {
          if (!key.startsWith('filter.p.m.custom.')) continue;
          const type = key.replace('filter.p.m.custom.', '');
          if (!newFilters.has(type)) newFilters.set(type, new Set());
          newFilters.get(type).add(value);
        }
        this.activeFilters = newFilters;
        
        this.applyFiltering();
        this.updateURL();
        this.updateCheckboxStates();
        this.refreshActiveFacets();
        this.updateFilterCheckboxText();
        return false;
      }
    }, true);
  }

  applyFiltering() {
    // If we have filters active and all products data loaded, render from JSON
    if (this.activeFilters.size > 0 && this.allProductsLoaded) {
      this.isClientFiltering = true;
      this.renderAllFilteredProducts();
      return;
    }
    
    // No filters - restore original products if we were in client mode
    if (this.activeFilters.size === 0 && this.isClientFiltering) {
      this.isClientFiltering = false;
      this.restoreOriginalProducts();
      return;
    }
    
    // Fallback to DOM-based filtering
    if (this.allProducts.length === 0) return;
    
    let visibleCount = 0;
    this.allProducts.forEach((productElement) => {
      const shouldShow = this.productMatchesFilters(productElement);
      productElement.style.display = shouldShow ? '' : 'none';
      productElement.setAttribute('data-metaobject-visible', shouldShow ? 'true' : 'false');
      if (shouldShow) visibleCount++;
    });
    
    this.updateProductCount(visibleCount);
    this.updatePaginationVisibility();
    this.updateAllCounts();
    this.clearFacetLoading();
  }

  renderAllFilteredProducts() {
    if (!this.allProductsLoaded || this.allProductsData.length === 0) return;
    
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    
    // Filter all products using JSON data
    const filteredProducts = this.allProductsData.filter(product => {
      return this.productDataMatchesFilters(product);
    });
    
    // Generate product cards HTML
    const productCardsHTML = filteredProducts.map((product, index) => {
      return this.renderProductCard(product, index);
    }).join('');
    
    // Replace grid content
    productGrid.innerHTML = productCardsHTML;
    
    // Update stored products reference
    this.allProducts = Array.from(productGrid.children);
    
    // Update count and hide pagination
    this.updateProductCount(filteredProducts.length);
    this.updatePaginationVisibility();
    this.updateAllCounts();
    this.clearFacetLoading();
  }

  productDataMatchesFilters(productData) {
    if (this.activeFilters.size === 0) return true;
    if (!productData.metafields) return false;
    
    for (let [filterType, filterValues] of this.activeFilters) {
      const productValue = productData.metafields[filterType];
      if (!productValue || !filterValues.has(productValue)) {
        return false;
      }
    }
    return true;
  }

  renderProductCard(product, index) {
    const price = product.price ? (product.price / 100).toFixed(2) : '0.00';
    const priceFormatted = parseFloat(price).toLocaleString('hr-HR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const imageUrl = product.featured_image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
    const animationDelay = Math.min(index, 10) * 0.05;
    
    // Build metafields JSON for the card
    const metafieldsJson = JSON.stringify({
      id: product.id,
      metafields: product.metafields || {}
    });
    
    return `
      <li class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${index};" data-cascade>
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <script type="application/json" data-product-metafields>${metafieldsJson}</script>
          <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 100%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img
                    srcset="${imageUrl}&width=165 165w, ${imageUrl}&width=360 360w, ${imageUrl}&width=533 533w, ${imageUrl}&width=720 720w"
                    src="${imageUrl}&width=533"
                    sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"
                    alt="${this.escapeHtml(product.title)}"
                    class="motion-reduce"
                    loading="lazy"
                    width="533"
                    height="533"
                  >
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                    <a href="${product.url}" class="full-unstyled-link">
                      ${this.escapeHtml(product.title)}
                    </a>
                  </h3>
                </div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${product.url}" class="full-unstyled-link">
                    ${this.escapeHtml(product.title)}
                  </a>
                </h3>
                <div class="card-information">
                  ${product.vendor ? `<span class="visually-hidden">Proizvođač:</span><div class="caption-with-letter-spacing light">${this.escapeHtml(product.vendor)}</div>` : ''}
                  <span class="caption-large light"></span>
                  <div class="price">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="price-item price-item--regular">${priceFormatted} EUR</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  restoreOriginalProducts() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid || this.originalProducts.length === 0) {
      // No original products stored, reload the page
      window.location.reload();
      return;
    }
    
    // Restore original products
    productGrid.innerHTML = '';
    this.originalProducts.forEach(product => {
      productGrid.appendChild(product.cloneNode(true));
    });
    
    this.allProducts = Array.from(productGrid.children);
    this.allProducts.forEach(p => {
      p.style.display = '';
      p.setAttribute('data-metaobject-visible', 'true');
    });
    
    this.updateProductCount(this.allProducts.length);
    this.updatePaginationVisibility();
    this.clearFacetLoading();
  }

  productMatchesFilters(productElement) {
    if (this.activeFilters.size === 0) return true;

    const metafieldScript = productElement.querySelector('[data-product-metafields]');
    if (!metafieldScript) return true;

    try {
      const productData = JSON.parse(metafieldScript.textContent);
      for (let [filterType, filterValues] of this.activeFilters) {
        const productValue = productData.metafields[filterType];
        if (!productValue || !filterValues.has(productValue)) {
          return false;
        }
      }
      return true;
    } catch (e) {
      return true;
    }
  }

  updateCheckboxStates() {
    document.querySelectorAll('[data-metaobject-filter]').forEach(input => {
      const filterType = input.dataset.metaobjectFilter;
      const filterValue = input.value;
      input.checked = this.activeFilters.has(filterType) && 
                     this.activeFilters.get(filterType).has(filterValue);
    });
  }

  updateURL() {
    const url = new URL(window.location);
    
    // Remove existing custom filter params
    for (let key of Array.from(url.searchParams.keys())) {
      if (key.startsWith('filter.p.m.custom.')) {
        url.searchParams.delete(key);
      }
    }
    
    // Add current custom filters
    for (let [filterType, filterValues] of this.activeFilters) {
      filterValues.forEach(filterValue => {
        url.searchParams.append(`filter.p.m.custom.${filterType}`, filterValue);
      });
    }
    
    // Remove page param when custom filters are active (we show all products)
    if (this.activeFilters.size > 0) {
      url.searchParams.delete('page');
    }
    
    history.replaceState(null, '', url.toString());
  }

  updateProductCount(visibleCount) {
    const selectors = [
      '#ProductCount',
      '#ProductCountDesktop'
    ];
    
    selectors.forEach(selector => {
      const element = document.querySelector(selector);
      if (!element) return;
      
      if (this.activeFilters.size > 0 || this.isClientFiltering) {
        // Custom filters are active - show "X od Y proizvoda" format
        const totalProducts = this.allProductsLoaded ? this.allProductsData.length : this.originalProducts.length;
        element.textContent = `${visibleCount} od ${totalProducts} proizvoda`;
        element.classList.remove('loading');
      } else {
        // No custom filters - show original format if we have it
        const total = this.allProductsLoaded ? this.allProductsData.length : visibleCount;
        element.textContent = `${total} proizvoda`;
        element.classList.remove('loading');
      }
    });
  }

  refreshActiveFacets() {
    const activeFacetsContainer = document.getElementById('HaustActiveFacetsPills');
    if (!activeFacetsContainer) return;

    activeFacetsContainer.querySelectorAll('[data-metaobject-facet]').forEach(facet => facet.remove());

    for (let [filterType, filterValues] of this.activeFilters) {
      filterValues.forEach(filterValue => {
        this.addActiveFacetPill(activeFacetsContainer, filterType, filterValue);
      });
    }
  }

  addActiveFacetPill(container, filterType, filterValue) {
    // Get filter name from the DOM filter section
    const filterSection = document.querySelector(`[data-metaobject-type="${filterType}"]`);
    let filterName = filterType.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    
    if (filterSection) {
      const summaryLabel = filterSection.querySelector('.haust-facets__summary-label');
      if (summaryLabel) {
        // Extract just the filter name, removing any count like "(4)"
        filterName = summaryLabel.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
      }
    }
    
    const displayText = this.displayValues[filterValue] || 'Value';
    
    const removeUrl = new URL(window.location);
    removeUrl.searchParams.delete(`filter.p.m.custom.${filterType}`);
    
    // Create HTML string first to avoid custom element initialization issues
    const facetHTML = `
      <facet-remove data-metaobject-facet="${filterType}:${filterValue}">
        <a href="${removeUrl.toString()}" class="active-facets__button active-facets__button--light">
          <span class="active-facets__button-inner button button--tertiary">
            ${filterName}: ${displayText}
            <span class="svg-wrapper">
              <svg viewBox="0 0 12 12" class="icon icon-close-small" aria-hidden="true" focusable="false">
                <path d="m8.48 4.14-1.75 1.75 1.75 1.75a.75.75 0 1 1-1.06 1.06L5.67 6.95 3.92 8.7a.75.75 0 0 1-1.06-1.06L4.61 5.89 2.86 4.14a.75.75 0 0 1 1.06-1.06L5.67 4.83l1.75-1.75a.75.75 0 0 1 1.06 1.06Z" fill="currentColor"></path>
              </svg>
            </span>
            <span class="visually-hidden">Clear filter</span>
          </span>
        </a>
      </facet-remove>
    `;

    // Insert HTML at the beginning of container
    const firstChild = container.firstElementChild;
    if (firstChild) {
      firstChild.insertAdjacentHTML('beforebegin', facetHTML);
    } else {
      container.insertAdjacentHTML('beforeend', facetHTML);
    }
  }

  updatePaginationVisibility() {
    // Hide pagination when client-side filtering is active
    const paginationSelectors = [
      '.pagination-wrapper',
      '.pagination',
      'nav.pagination-wrapper'
    ];
    
    paginationSelectors.forEach(selector => {
      const pagination = document.querySelector(selector);
      if (pagination) {
        if (this.isClientFiltering || this.activeFilters.size > 0) {
          pagination.style.display = 'none';
        } else {
          pagination.style.display = '';
        }
      }
    });
  }

  updateAllCounts() {
    const counts = {
      availability: {},
      vendor: {},
      product_type: {},
      metaobjects: {}
    };

    if (!this.allProductsLoaded) return;

    this.allProductsData.forEach((productData) => {
      if (productData.availability) {
        counts.availability[productData.availability] = (counts.availability[productData.availability] || 0) + 1;
      }

      if (productData.vendor) {
        counts.vendor[productData.vendor] = (counts.vendor[productData.vendor] || 0) + 1;
      }

      if (productData.product_type) {
        counts.product_type[productData.product_type] = (counts.product_type[productData.product_type] || 0) + 1;
      }
      
      if (productData.metafields) {
        Object.entries(productData.metafields).forEach(([metaobjectType, gid]) => {
          if (!gid || gid === '') return;
          if (!counts.metaobjects[metaobjectType]) {
            counts.metaobjects[metaobjectType] = {};
          }
          counts.metaobjects[metaobjectType][gid] = (counts.metaobjects[metaobjectType][gid] || 0) + 1;
        });
      }
    });

    document.querySelectorAll('input[data-haust-filter="vendor"]').forEach(input => {
      const value = input.dataset.haustValue;
      const count = counts.vendor[value] || 0;
      const label = input.closest('label');
      if (label) {
        const textSpan = label.querySelector('.haust-facet-checkbox__text');
        const textLabel = label.querySelector('.haust-facet-checkbox__text-label');
        if (textSpan && textLabel) {
          const labelText = textLabel.textContent.replace(/\s*\(\d+\)$/, '');
          textSpan.innerHTML = `<span class="haust-facet-checkbox__text-label">${labelText}</span> (${count})`;
        }
      }
    });

    document.querySelectorAll('input[data-haust-filter="product_type"]').forEach(input => {
      const value = input.dataset.haustValue;
      const count = counts.product_type[value] || 0;
      const label = input.closest('label');
      if (label) {
        const textSpan = label.querySelector('.haust-facet-checkbox__text');
        const textLabel = label.querySelector('.haust-facet-checkbox__text-label');
        if (textSpan && textLabel) {
          const labelText = textLabel.textContent.replace(/\s*\(\d+\)$/, '');
          textSpan.innerHTML = `<span class="haust-facet-checkbox__text-label">${labelText}</span> (${count})`;
        }
      }
    });

    document.querySelectorAll('input[data-metaobject-filter]').forEach(input => {
      const metaobjectType = input.dataset.metaobjectFilter;
      const gid = input.dataset.haustValue;
      const count = counts.metaobjects[metaobjectType]?.[gid] || 0;
      const label = input.closest('label');
      if (label) {
        const textSpan = label.querySelector('.haust-facet-checkbox__text');
        const textLabel = label.querySelector('.haust-facet-checkbox__text-label');
        if (textSpan && textLabel) {
          const labelText = textLabel.textContent.replace(/\s*\(\d+\)$/, '');
          textSpan.innerHTML = `<span class="haust-facet-checkbox__text-label">${labelText}</span> (${count})`;
        }
      }
    });

    this.updateSelectedCounts();
    this.updateMetaobjectDisplayText();
  }

  updateSelectedCounts() {
    document.querySelectorAll('.haust-facets__disclosure-vertical').forEach(details => {
      const selectedSpan = details.querySelector('.haust-facets__selected');
      if (!selectedSpan) return;
      
      const checkedInputs = details.querySelectorAll('input[type="checkbox"]:checked');
      if (checkedInputs.length > 0) {
        selectedSpan.textContent = `(${checkedInputs.length})`;
        selectedSpan.classList.remove('hidden');
      } else {
        selectedSpan.classList.add('hidden');
      }
    });
  }

  updateMetaobjectDisplayText() {
    document.querySelectorAll('[data-gid]').forEach(element => {
      const gid = element.getAttribute('data-gid');
      const displayText = this.displayValues[gid];
      if (displayText) {
        const textLabel = element.querySelector('.haust-facet-checkbox__text-label');
        if (textLabel && !textLabel.textContent.includes('(')) {
          textLabel.textContent = displayText;
        }
      }
    });
  }

  clearFacetLoading() {
    const facetForms = document.querySelectorAll('.facets__form, #FacetFiltersForm');
    facetForms.forEach(form => {
      form.classList?.remove('facets--loading');
    });
  }
}

// Initialize
new MetaobjectFacets();